import { jsx as e, jsxs as t } from "react/jsx-runtime";
const C = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("polygon", { points: "13 11 18 11 18 13 13 13 13 18 11 18 11 13 6 13 6 11 11 11 11 6 13 6" }) }), h = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("polygon", { points: "13 11 17 11 17 13 13 13 13 17 11 17 11 13 7 13 7 11 11 11 11 7 13 7" }) }), l = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 6H10.8V10.8H6V13.2H10.8L10.8 18H13.2L13.2 13.2L18 13.2V10.8L13.2 10.8V6Z"
  }
) }), o = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M6 11h12v2H6z" }) }), d = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70078 7.19922V5.59922H14.3008V7.19922H9.70078ZM8.30078 7.19922V5.39922C8.30078 4.73648 8.83804 4.19922 9.50078 4.19922H14.5008C15.1635 4.19922 15.7008 4.73648 15.7008 5.39922V7.19922H15.7427H18.0008C18.3874 7.19922 18.7008 7.51262 18.7008 7.89922C18.7008 8.28582 18.3874 8.59922 18.0008 8.59922H16.9301L16.0969 18.4999C16.0446 19.1214 15.5248 19.5992 14.9011 19.5992H9.10047C8.47674 19.5992 7.957 19.1214 7.9047 18.4999L7.0715 8.59922H6.00078C5.61418 8.59922 5.30078 8.28582 5.30078 7.89922C5.30078 7.51262 5.61418 7.19922 6.00078 7.19922H8.25891H8.30078ZM15.0008 8.59922H9.00078H8.47645L9.28435 18.1992H14.7172L15.5251 8.59922H15.0008Z",
    fill: "#1A91F0"
  }
) }), n = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M13,8.57080187 L13,19 L11,19 L11,8.57080187 L7.23715414,12.6757246 L5.76284586,11.3242754 L11.2628459,5.32427537 C11.6591824,4.89190821 12.3408176,4.89190821 12.7371541,5.32427537 L18.2371541,11.3242754 L16.7628459,12.6757246 L13,8.57080187 Z" }) }), s = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M11,16.4291981 L11,5.5 L13,5.5 L13,16.4291981 L16.7628459,12.3242754 L18.2371541,13.6757246 L12.7371541,19.6757246 C12.3408176,20.1080918 11.6591824,20.1080918 11.2628459,19.6757246 L5.76284586,13.6757246 L7.23715414,12.3242754 L11,16.4291981 Z" }) }), r = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0zm-2 0a1 1 0 11-2 0 1 1 0 012 0z M5 9h2v6H5V9zM19 9h-2v6h2V9z M2 6a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6zm2 11V7h16v10H4z"
  }
) }), a = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M21 5H3v2h18V5zm0 4H3v2h18V9zM3 13h18v2H3v-2zm11.5 4H3v2h11.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z" }) }), L = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6V5h4v1h-4zM8 4a1 1 0 011-1h6a1 1 0 011 1h3a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h3zm8 2v1a1 1 0 01-1 1H9a1 1 0 01-1-1V6H6v12h1.1a5.009 5.009 0 013.043-3.644 3 3 0 113.714 0A5.009 5.009 0 0116.9 18H18V6h-2zm-4 10c1.306 0 2.417.835 2.83 2H9.17A3.001 3.001 0 0112 16zm1-4a1 1 0 11-2 0 1 1 0 012 0z"
  }
) }), c = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M9.431 7.257l1.352-1.474 5.893 5.48a1 1 0 0 1 0 1.474l-5.893 5.45-1.352-1.475L14.521 12 9.43 7.257z" }) }), v = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M8,19 L16,19 L16,13 L8,13 L8,19 Z M16,7 L20,7 L20,9 L4,9 L4,7 L8,7 L8,3 L16,3 L16,7 Z M14,7 L14,5 L10,5 L10,7 L14,7 Z M6,11 L18,11 L18,21 L6,21 L6,11 Z",
    fillRule: "nonzero"
  }
) }), V = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M5.5 5.5v4h4v-4h-4zM11 4v7H4V4h7zm3.5 1.5v4h4v-4h-4zM20 4v7h-7V4h7zM5.5 14.5v4h4v-4h-4zM11 13v7H4v-7h7zm3.5 1.5v4h4v-4h-4zM20 13v7h-7v-7h7z" }) }), w = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M16.6917162,8.75389189 L18.3082838,10.2461081 L12.3082838,16.7461081 C11.8845221,17.2051833 11.1639539,17.2195889 10.7221825,16.7778175 L6.22218254,12.2778175 L7.77781746,10.7221825 L11.4682653,14.4126304 L16.6917162,8.75389189 Z" }) }), g = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M20 7.40113L11.1061 17.4761C10.502 18.1605 9.45117 18.1766 8.82691 17.5111L4 12.3648L5.49827 10.9171L9.9391 15.6517L18.4593 6L20 7.40113Z" }) }), p = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21 7.4-8.9 10.08c-.6.68-1.65.7-2.27.03L5 12.36l1.5-1.44 4.44 4.73L19.46 6 21 7.4Z"
  }
) }), M = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M9.32427537,7.23715414 L10.6757246,5.76284586 L16.6757246,11.2628459 C17.1080918,11.6591824 17.1080918,12.3408176 16.6757246,12.7371541 L10.6757246,18.2371541 L9.32427537,16.7628459 L14.5201072,12 L9.32427537,7.23715414 Z" }) }), f = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5684 16.743L13.2169 18.2173L7.32379 12.7371C6.89142 12.3408 6.89142 11.6591 7.32379 11.2628L13.2169 5.81372L14.5684 7.28803L9.4794 11.9999L14.5684 16.743Z",
        fill: "currentColor"
      }
    )
  }
), Z = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.42969 7.25556L10.7811 5.78125L16.6743 11.2614C17.1066 11.6578 17.1066 12.3394 16.6743 12.7358L10.7811 18.1848L9.42969 16.7105L14.5186 11.9986L9.42969 7.25556Z"
      }
    )
  }
), u = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M17 14L12 9L7 14",
        stroke: "#0F141E",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), x = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M11.987107,10.5728934 L16.2800002,6.28000021 L17.6942138,7.69421377 L13.4013206,11.987107 L17.6942138,16.2800002 L16.2800002,17.6942138 L11.987107,13.4013206 L7.69421377,17.6942138 L6.28000021,16.2800002 L10.5728934,11.987107 L6.28000021,7.69421377 L7.69421377,6.28000021 L11.987107,10.5728934 Z" }) }), H = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("rect", { width: "28", height: "28", rx: "14", fill: "white" }),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.9498 12.5356L10.4142 9L9 10.4142L12.5356 13.9498L9.00003 17.4853L10.4142 18.8995L13.9498 15.364L17.4853 18.8995L18.8995 17.4853L15.364 13.9498L18.8995 10.4142L17.4853 9.00001L13.9498 12.5356Z",
          fill: "#828BA2"
        }
      )
    ]
  }
), k = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M10.5857864,12 L3.79289322,5.20710678 L5.20710678,3.79289322 L12,10.5857864 L18.7928932,3.79289322 L20.2071068,5.20710678 L13.4142136,12 L20.2071068,18.7928932 L18.7928932,20.2071068 L12,13.4142136 L5.20710678,20.2071068 L3.79289322,18.7928932 L10.5857864,12 Z" }) }), B = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M4.29285 18.2928L5.70706 19.7071L12 13.4142L18.2928 19.7071L19.7071 18.2928L13.4142 12L19.7071 5.70706L18.2928 4.29285L12 10.5857L5.70706 4.29285L4.29285 5.70706L10.5857 12L4.29285 18.2928Z" }) }), m = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M11.835 17h1.615L8.89 5.03H7.56L3 17h1.615l1.14-2.945h4.94L11.835 17zm-3.61-9.5l1.995 5.225H6.23L8.225 7.5zM17.9113 8.355c-1.9 0-3.04 1.14-3.23 2.565h1.52c.19-.76.665-1.235 1.71-1.235s1.805.76 1.805 1.615v.475c-4.275 0-5.415 1.14-5.415 2.755 0 1.425 1.14 2.565 2.85 2.565 1.71 0 2.565-1.045 2.565-1.045l.38.95h1.045v-5.7c0-1.615-1.33-2.945-3.23-2.945zm-.76 7.41c-.855 0-1.425-.57-1.425-1.14 0-.95.57-1.52 3.99-1.52v.665c0 .95-1.045 1.995-2.565 1.995z" }) }), R = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.45 17h-1.615l-1.14-2.945h-4.94L4.615 17H3L7.56 5.03h1.33L13.45 17zm-3.23-4.275L8.225 7.5 6.23 12.725h3.99zM15.8999 11.0004V12H15.5c-.2761 0-.5.2239-.5.5v4c0 .2761.2239.5.5.5h6c.2761 0 .5-.2239.5-.5v-4c0-.2761-.2239-.5-.5-.5h-.4001v-.9996c0-.4972-.117-1.14079-.5218-1.67492-.4265-.56273-1.1131-.92509-2.0782-.92509-.9651 0-1.6517.36236-2.0782.92509-.4048.53413-.5218 1.17772-.5218 1.67492zm1.4782-.9501c-.1952.2575-.2782.614-.2782.9501V12h2.8v-.9996c0-.3361-.083-.6926-.2782-.9501-.1735-.22893-.4869-.44991-1.1218-.44991-.6349 0-.9483.22098-1.1218.44991z"
  }
) }), F = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M15.835 17H17.45L12.89 5.03003H11.56L7 17H8.615L9.755 14.055H14.695L15.835 17ZM12.225 7.50003L14.22 12.725H10.23L12.225 7.50003Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 22H3V21.3H21V22Z", fill: "white" }),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 1.99999H3V1.29999H21V1.99999Z",
          fill: "white"
        }
      )
    ]
  }
), _ = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("mask", { id: "mask0_3984_1940", maskUnits: "userSpaceOnUse", x: "0", y: "4", width: "24", height: "16", children: /* @__PURE__ */ e("path", { d: "M24 4H0V20H24V4Z", fill: "white" }) }),
      /* @__PURE__ */ t("g", { mask: "url(#mask0_3984_1940)", children: [
        /* @__PURE__ */ e("mask", { id: "mask1_3984_1940", maskUnits: "userSpaceOnUse", x: "0", y: "4", width: "24", height: "16", children: /* @__PURE__ */ e("path", { d: "M24 4H0V20H24V4Z", fill: "white" }) }),
        /* @__PURE__ */ t("g", { mask: "url(#mask1_3984_1940)", children: [
          /* @__PURE__ */ e("path", { d: "M0 12C0 16.4183 3.58172 20 8 20V4C3.58172 4 0 7.58173 0 12Z", fill: "#1D264A" }),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M8.5 12.5C8.5 16.6421 11.8579 20 16 20V11.5C16 7.35787 12.6421 4 8.5 4V12.5Z",
              fill: "#C6E8E6"
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              d: "M16.5 12.5C16.5 16.6421 19.8579 20 24 20V11.5C24 7.35787 20.6421 4 16.5 4V12.5Z",
              fill: "#C6E8E6"
            }
          )
        ] })
      ] })
    ]
  }
), A = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M8,17 L12,17 L12,19 L6,19 L6,13 L8,13 L8,17 Z M18,6 L18,12 L16,12 L16,8 L12,8 L12,6 L18,6 Z" }) }), z = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M7 17h4v2H5v-6h2v4zM19 5v6h-2V7h-4V5h6z" }) }), b = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M13,6.16414207 L13,13 L11,13 L11,6.16414207 L8.5,8.25257669 L7.18299078,6.74742331 L11.3414954,3.24742331 C11.7185214,2.91752556 12.2814786,2.91752556 12.6585046,3.24742331 L16.8170092,6.74742331 L15.5,8.25257669 L13,6.16414207 Z M16,18 L16,11 L18,11 L18,19 C18,19.5522847 17.5522847,20 17,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,11 L8,11 L8,18 L16,18 Z" }) }), W = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M12 6C8.46687 6 5.37921 8.01049 3.6911 11.0097C3.5299 11.2961 3.31086 11.7813 3.16293 12.1201C3.05691 12.3628 3.05604 12.6378 3.16037 12.8813C3.27961 13.1597 3.44162 13.5262 3.56075 13.7514C5.217 16.8823 8.37388 19 12 19C15.6054 19 18.7468 16.9066 20.4106 13.8053C20.5386 13.5668 20.7126 13.1751 20.8383 12.8829C20.9435 12.6384 20.9425 12.3621 20.8354 12.1185C20.6782 11.761 20.4401 11.2373 20.2645 10.9315C18.567 7.97556 15.5024 6 12 6ZM12 16.8333C9.74186 16.8333 7.90913 14.892 7.90913 12.5C7.90913 10.108 9.74186 8.16667 12 8.16667C14.2582 8.16667 16.0909 10.108 16.0909 12.5C16.0909 14.892 14.2582 16.8333 12 16.8333ZM12 9.9C10.6419 9.9 9.54549 11.0613 9.54549 12.5C9.54549 13.9387 10.6419 15.1 12 15.1C13.3582 15.1 14.4546 13.9387 14.4546 12.5C14.4546 11.0613 13.3582 9.9 12 9.9Z",
    fill: "currentColor"
  }
) }), y = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M6,17 L6,15 L8,15 L8,17 L21,17 L21,19 L8,19 L8,21 L6,21 L6,19 L3,19 L3,17 L6,17 Z M16,11 L16,9 L18,9 L18,11 L21,11 L21,13 L18,13 L18,15 L16,15 L16,13 L3,13 L3,11 L16,11 Z M6,5 L6,3 L8,3 L8,5 L21,5 L21,7 L8,7 L8,9 L6,9 L6,7 L3,7 L3,5 L6,5 Z" }) }), E = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M8,17 L8,7 L11.7707948,7 C13.0770244,7 14.0677723,7.23236947 14.7430684,7.69711538 C15.4183644,8.1618613 15.7560074,8.84294423 15.7560074,9.74038462 C15.7560074,10.2303138 15.6204573,10.6618571 15.349353,11.0350275 C15.0782488,11.4081978 14.7011731,11.6817757 14.2181146,11.8557692 C14.7701814,11.983975 15.205174,12.242672 15.5231054,12.6318681 C15.8410367,13.0210642 16,13.4972499 16,14.0604396 C16,15.0219828 15.6697507,15.7499975 15.0092421,16.2445055 C14.3487336,16.7390135 13.4072766,16.9908424 12.1848429,17 L8,17 Z M10.2181146,12.6456044 L10.2181146,15.3447802 L12.1182994,15.3447802 C12.6407913,15.3447802 13.0486738,15.2291678 13.3419593,14.9979396 C13.6352448,14.7667113 13.7818854,14.4473464 13.7818854,14.0398352 C13.7818854,13.1240797 13.2717241,12.6593407 12.2513863,12.6456044 L10.2181146,12.6456044 Z M10.2181146,11.1895604 L11.8595194,11.1895604 C12.9784406,11.1712453 13.5378928,10.7568722 13.5378928,9.94642857 C13.5378928,9.4931296 13.3961813,9.1668966 13.1127542,8.96771978 C12.829327,8.76854296 12.3820117,8.66895604 11.7707948,8.66895604 L10.2181146,8.66895604 L10.2181146,11.1895604 Z" }) }), S = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M10.1737981,15.5714286 L11.5584135,8.42857143 L9.95714286,8.42857143 C9.7598983,8.42857143 9.6,8.26867312 9.6,8.07142857 L9.6,7.35714286 C9.6,7.1598983 9.7598983,7 9.95714286,7 L15.6428571,7 C15.8401017,7 16,7.1598983 16,7.35714286 L16,8.07142857 C16,8.26867312 15.8401017,8.42857143 15.6428571,8.42857143 L13.7330228,8.42857143 L12.3484075,15.5714286 L14.0428571,15.5714286 C14.2401017,15.5714286 14.4,15.7313269 14.4,15.9285714 L14.4,16.6428571 C14.4,16.8401017 14.2401017,17 14.0428571,17 L8.35714286,17 C8.1598983,17 8,16.8401017 8,16.6428571 L8,15.9285714 C8,15.7313269 8.1598983,15.5714286 8.35714286,15.5714286 L10.1737981,15.5714286 Z" }) }), j = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M9,6.7 L9,8.3 C9,8.41045695 9.08954305,8.5 9.2,8.5 L19.8,8.5 C19.9104569,8.5 20,8.41045695 20,8.3 L20,6.7 C20,6.58954305 19.9104569,6.5 19.8,6.5 L9.2,6.5 C9.08954305,6.5 9,6.58954305 9,6.7 Z M9.2,18.5 L19.8,18.5 C19.9104569,18.5 20,18.4104569 20,18.3 L20,16.7 C20,16.5895431 19.9104569,16.5 19.8,16.5 L9.2,16.5 C9.08954305,16.5 9,16.5895431 9,16.7 L9,18.3 C9,18.4104569 9.08954305,18.5 9.2,18.5 Z M9.2,13.5 C9.08954305,13.5 9,13.4104569 9,13.3 L9,11.7 C9,11.5895431 9.08954305,11.5 9.2,11.5 L19.8,11.5 C19.9104569,11.5 20,11.5895431 20,11.7 L20,13.3 C20,13.4104569 19.9104569,13.5 19.8,13.5 L9.2,13.5 Z M5.5,9 C4.67157288,9 4,8.32842712 4,7.5 C4,6.67157288 4.67157288,6 5.5,6 C6.32842712,6 7,6.67157288 7,7.5 C7,8.32842712 6.32842712,9 5.5,9 Z M5.5,14 C4.67157288,14 4,13.3284271 4,12.5 C4,11.6715729 4.67157288,11 5.5,11 C6.32842712,11 7,11.6715729 7,12.5 C7,13.3284271 6.32842712,14 5.5,14 Z M5.5,19 C4.67157288,19 4,18.3284271 4,17.5 C4,16.6715729 4.67157288,16 5.5,16 C6.32842712,16 7,16.6715729 7,17.5 C7,18.3284271 6.32842712,19 5.5,19 Z" }) }), D = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M9,6.2 L9,7.8 C9,7.91045695 9.08954305,8 9.2,8 L19.8,8 C19.9104569,8 20,7.91045695 20,7.8 L20,6.2 C20,6.08954305 19.9104569,6 19.8,6 L9.2,6 C9.08954305,6 9,6.08954305 9,6.2 Z M9.2,18 L19.8,18 C19.9104569,18 20,17.9104569 20,17.8 L20,16.2 C20,16.0895431 19.9104569,16 19.8,16 L9.2,16 C9.08954305,16 9,16.0895431 9,16.2 L9,17.8 C9,17.9104569 9.08954305,18 9.2,18 Z M9.2,13 C9.08954305,13 9,12.9104569 9,12.8 L9,11.2 C9,11.0895431 9.08954305,11 9.2,11 L19.8,11 C19.9104569,11 20,11.0895431 20,11.2 L20,12.8 C20,12.9104569 19.9104569,13 19.8,13 L9.2,13 Z M4,16 L4,15 L7,15 L7,19 L4,19 L4,18 L6,18 L6,17.5 L5,17.5 L5,16.5 L6,16.5 L6,16 L4,16 Z M5,9 L5,6 L4,6 L4,5 L6,5 L6,9 L5,9 Z M4,11 L4,10 L7,10 L7,10.9 L5.2,13 L7,13 L7,14 L4,14 L4,13.1 L5.8,11 L4,11 Z" }) }), U = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M8.218776,10.6611638 C7.9938233,10.2394416 7.88134766,9.77395634 7.88134766,9.26470588 C7.88134766,8.63368668 8.0527191,8.07085809 8.39546712,7.57620321 C8.73821515,7.08154833 9.23042485,6.69518856 9.872111,6.4171123 C10.5137972,6.13903604 11.2340726,6 12.032959,6 C12.8369995,6 13.5534094,6.15106801 14.1822103,6.45320856 C14.8110112,6.7553491 15.2993554,7.18181543 15.6472575,7.73262032 C15.9951596,8.28342521 16.1691081,8.90908741 16.1691081,9.60962567 L13.8497721,9.60962567 C13.8497721,9.07486364 13.6874202,8.65909239 13.3627116,8.36229947 C13.0380029,8.06550654 12.5818714,7.9171123 11.9943034,7.9171123 C11.4273518,7.9171123 10.9866823,8.04144261 10.6722819,8.29010695 C10.3578815,8.5387713 10.2006836,8.86630813 10.2006836,9.27272727 C10.2006836,9.65240832 10.3849401,9.97058695 10.7534587,10.2272727 C10.9695179,10.3777654 11.2453678,10.5227422 11.5810116,10.6622047 C10.7381999,10.6611638 9.35727946,10.6622047 8.218776,10.6611638 Z M13.842041,14.7754011 C13.842041,14.3208533 13.6874202,13.9719264 13.3781738,13.7286096 C13.2203718,13.6044501 12.9981534,13.4768105 12.7115165,13.3456897 C12.9823481,13.3439472 15.4837341,13.3456897 15.8720434,13.3439472 C16.0700871,13.7665751 16.1691081,14.2383774 16.1691081,14.7593583 C16.1691081,15.7700585 15.800595,16.5628314 15.0635579,17.1377005 C14.3265208,17.7125697 13.3343704,18 12.0870768,18 C11.2211871,18 10.4326207,17.8355631 9.72135417,17.5066845 C9.01008759,17.1778058 8.46762611,16.7272756 8.09395345,16.1550802 C7.72028079,15.5828848 7.53344727,14.9197899 7.53344727,14.1657754 L9.86051432,14.1657754 C9.86051432,15.4545519 10.6026944,16.0989305 12.0870768,16.0989305 C12.6385661,16.0989305 13.0689275,15.9826215 13.3781738,15.75 C13.6874202,15.5173785 13.842041,15.1925155 13.842041,14.7754011 Z M7.43231072,11.3549113 L16.5676893,11.3549113 C16.8064479,11.3549113 17,11.5484634 17,11.7872221 L17,12.2195328 C17,12.4582914 16.8064479,12.6518435 16.5676893,12.6518435 L7.43231072,12.6518435 C7.1935521,12.6518435 7,12.4582914 7,12.2195328 L7,11.7872221 C7,11.5484634 7.1935521,11.3549113 7.43231072,11.3549113 Z" }) }), T = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M16.3453125,7 L16.3453125,13.402819 C16.3453125,14.4666225 15.951127,15.3078604 15.1627441,15.9265579 C14.3743613,16.5452553 13.2972725,16.8545994 11.9314453,16.8545994 C10.586712,16.8545994 9.51885161,16.5541573 8.72783203,15.9532641 C7.93681245,15.3523709 7.53339852,14.5267115 7.51757812,13.4762611 L7.51757812,7 L9.890625,7 L9.890625,13.4161721 C9.890625,14.0526738 10.0712384,14.5166899 10.4324707,14.8082344 C10.793703,15.0997789 11.2933562,15.245549 11.9314453,15.245549 C13.2656317,15.245549 13.9432616,14.6535668 13.9643555,13.4695846 L13.9643555,7 L16.3453125,7 Z M7.87982196,17.4807122 L16.120178,17.4807122 C16.3299479,17.4807122 16.5,17.6507642 16.5,17.8605341 L16.5,18.620178 C16.5,18.8299479 16.3299479,19 16.120178,19 L7.87982196,19 C7.67005208,19 7.5,18.8299479 7.5,18.620178 L7.5,17.8605341 C7.5,17.6507642 7.67005208,17.4807122 7.87982196,17.4807122 Z" }) }), O = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M16.2130943,7.78690569 C15.2823632,6.85617459 13.77335,6.85617459 12.8426189,7.78690569 L7.78690569,12.8426189 C6.85617459,13.77335 6.85617459,15.2823632 7.78690569,16.2130943 C8.71763678,17.1438254 10.22665,17.1438254 11.1573811,16.2130943 L16.2130943,11.1573811 C17.1438254,10.22665 17.1438254,8.71763678 16.2130943,7.78690569 Z M13.943728,15.6737311 L12.280873,17.3365861 C10.7296545,18.8878046 8.21463236,18.8878046 6.66341387,17.3365861 C5.11219538,15.7853676 5.11219538,13.2703455 6.66341387,11.719127 L8.32626889,10.056272 L9.45091165,11.1809148 L11.1361494,9.49567706 L10.0115066,8.3710343 L11.719127,6.66341387 C13.2703455,5.11219538 15.7853676,5.11219538 17.3365861,6.66341387 C18.8878046,8.21463236 18.8878046,10.7296545 17.3365861,12.280873 L15.6289657,13.9884934 L15.6301166,13.9896443 L13.9448789,15.6748821 L13.943728,15.6737311 Z M13.943728,15.6737311 L15.6289657,13.9884934 L14.5054739,12.8650016 L12.8202362,14.5502393 L13.943728,15.6737311 Z M13.9658723,10.0344648 C13.6556286,9.72422109 13.1526242,9.72422109 12.8423805,10.0344648 L10.033651,12.8431943 C9.72340725,13.153438 9.72340725,13.6564425 10.033651,13.9666862 C10.3438947,14.2769299 10.8468991,14.2769299 11.1571428,13.9666862 L13.9658723,11.1579566 C14.276116,10.8477129 14.276116,10.3447085 13.9658723,10.0344648 Z" }) }), I = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M11.7289758,8.90054871 L10.605484,7.7770569 L11.719127,6.66341387 C13.2703455,5.11219538 15.7853676,5.11219538 17.3365861,6.66341387 C18.8878046,8.21463236 18.8878046,10.7296545 17.3365861,12.280873 L16.2229431,13.394516 L15.0994513,12.2710242 L16.2130943,11.1573811 C17.1438254,10.22665 17.1438254,8.71763678 16.2130943,7.78690569 C15.2823632,6.85617459 13.77335,6.85617459 12.8426189,7.78690569 L11.7289758,8.90054871 Z M8.90054871,11.7289758 L7.78690569,12.8426189 C6.85617459,13.77335 6.85617459,15.2823632 7.78690569,16.2130943 C8.71763678,17.1438254 10.22665,17.1438254 11.1573811,16.2130943 L12.2710242,15.0994513 L13.394516,16.2229431 L12.280873,17.3365861 C10.7296545,18.8878046 8.21463236,18.8878046 6.66341387,17.3365861 C5.11219538,15.7853676 5.11219538,13.2703455 6.66341387,11.719127 L7.7770569,10.605484 L8.90054871,11.7289758 Z M13.9760363,11.1476092 L12.8527279,10.0243008 C13.1637094,9.72425892 13.6590544,9.72764691 13.9658723,10.0344648 C14.2726902,10.3412827 14.2760782,10.8366277 13.9760363,11.1476092 Z M11.1476231,13.9760503 C10.8366936,14.2768978 10.3407412,14.2737764 10.033651,13.9666862 C9.72656068,13.6595959 9.72343931,13.1636435 10.0242868,12.852714 L11.1476231,13.9760503 Z M6.43431458,7.56568542 L7.56568542,6.43431458 L17.5656854,16.4343146 L16.4343146,17.5656854 L6.43431458,7.56568542 Z" }) }), G = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M5.636 11.646l1.945-1.944 1.414 1.414-1.945 1.945a2.75 2.75 0 103.89 3.889l1.944-1.945 1.414 1.414-1.944 1.945a4.75 4.75 0 11-6.718-6.718zM16.95 10.94l-1.945 1.944 1.414 1.414 1.945-1.944a4.75 4.75 0 00-6.718-6.718L9.702 7.581l1.414 1.414 1.945-1.945a2.75 2.75 0 013.889 3.89z M9.313 13.273a.7.7 0 000 .99l.424.424a.7.7 0 00.99 0l3.96-3.96a.7.7 0 000-.99l-.424-.424a.7.7 0 00-.99 0l-3.96 3.96z" }) }), P = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M12.435 15.21L11.67 13H7.58995L6.82495 15.21H4.69995L8.69495 4.5H10.565L14.56 15.21H12.435ZM9.62995 7.22L8.26995 11.13H10.99L9.62995 7.22ZM19.9999 14.4288L18.5972 13L13.5527 18.4702L10.4027 15.812L8.99994 17.2408L12.8513 20.6135C13.3482 21.1196 13.7758 21.138 14.254 20.6135L19.9999 14.4288Z" }) }), N = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M12.435 15.21L11.67 13H7.58995L6.82495 15.21H4.69995L8.69495 4.5H10.565L14.56 15.21H12.435ZM9.62995 7.22L8.26995 11.13H10.99L9.62995 7.22Z" }) }), J = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M16.4292 11L12.3243 7.23718L13.6757 5.76287L19.6757 11.2629C20.1081 11.6592 20.1081 12.3408 19.6757 12.7372L13.6757 18.2372L12.3243 16.7629L16.4292 13L5.5 13L5.5 11L16.4292 11Z" }) }), Q = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M8,3.57080187 L8,14 L6,14 L6,3.57080187 L2.23715414,7.6757246 L0.76284586,6.3242754 L6.2628459,0.32427537 C6.6591824,-0.10809179 7.3408176,-0.10809179 7.7371541,0.32427537 L13.2371541,6.3242754 L11.7628459,7.6757246 L8,3.57080187 Z" }) }), Y = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M5 9h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1zm1 2v8h8v-8H6zm12-4H9V5h10a1 1 0 0 1 1 1v10h-2V7z" }) }), q = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M8.035 11.97h2.435v6.023h4.06V11.97h2.435L12.5 6.537 8.035 11.97zm-1.919 2.008A1.11 1.11 0 0 1 5 12.874c0-.254.088-.5.25-.696l6.384-7.77a1.125 1.125 0 0 1 1.57-.16c.087.074.087.074.162.16l6.384 7.77a1.096 1.096 0 0 1-.162 1.553c-.2.16-.448.247-.704.247H16.56v4.918c0 .61-.5 1.104-1.117 1.104H9.557a1.11 1.11 0 0 1-1.117-1.104v-4.918H6.116z" }) }), K = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M9,6 L9,13 L7.20376823,13 L12,18.4814077 L16.7962318,13 L15,13 L15,6 L9,6 Z M7,11 L7,5 C7,4.44771525 7.44771525,4 8,4 L16,4 C16.5522847,4 17,4.44771525 17,5 L17,11 L19,11 C19.8591588,11 20.3183367,12.0119217 19.7525767,12.6585046 L12.7525767,20.6585046 C12.3541654,21.1138318 11.6458346,21.1138318 11.2474233,20.6585046 L4.24742331,12.6585046 C3.68166327,12.0119217 4.14084119,11 5,11 L7,11 Z" }) }), X = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M11.5,15.5 C13.709139,15.5 15.5,13.709139 15.5,11.5 C15.5,9.290861 13.709139,7.5 11.5,7.5 C9.290861,7.5 7.5,9.290861 7.5,11.5 C7.5,13.709139 9.290861,15.5 11.5,15.5 Z M16.4027819,14.9595737 L18.6821579,17.1305862 L17.2679443,18.5447998 L14.9935823,16.3785629 C14.0096341,17.084429 12.803348,17.5 11.5,17.5 C8.1862915,17.5 5.5,14.8137085 5.5,11.5 C5.5,8.1862915 8.1862915,5.5 11.5,5.5 C14.8137085,5.5 17.5,8.1862915 17.5,11.5 C17.5,12.7883707 17.093925,13.9818975 16.4027819,14.9595737 Z" }) }), $ = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z" }) }), e1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M16.5 10.5L7.6133 19.3867C7.53961 19.4604 7.44474 19.5092 7.34195 19.5263L5.19048 19.8849C4.85207 19.9413 4.55868 19.6479 4.61508 19.3095L4.97366 17.1581C4.99079 17.0553 5.03961 16.9604 5.1133 16.8867L14 8M16.5 10.5L19.1464 7.85355C19.3417 7.65829 19.3417 7.34171 19.1464 7.14645L17.3536 5.35355C17.1583 5.15829 16.8417 5.15829 16.6464 5.35355L14 8M16.5 10.5L14 8",
    fill: "#fff",
    stroke: "#1A91F0",
    strokeWidth: "1.4"
  }
) }), i1 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  "(",
  /* @__PURE__ */ e("path", { d: "M6 12a6 6 0 101.5-4H10v2H5a1 1 0 01-1-1V4h2v2.7A8 8 0 0120 12a8 8 0 11-16 0h2z" })
] }), t1 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  "(",
  /* @__PURE__ */ e("path", { d: "M18 12a6 6 0 11-1.5-4H14v2h5c.6 0 1-.4 1-1V4h-2v2.7A8 8 0 004 12a8 8 0 1016 0h-2z" })
] }), C1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fill: "currentColor",
    d: "M9.73 6.486v2.478H8v3.03h1.73l.013 8.506h3.552l-.014-8.505h2.384s.223-1.453.331-3.042h-2.701V6.881c0-.31.387-.726.77-.726H16V3h-2.631c-3.728 0-3.64 3.033-3.64 3.486z"
  }
) }), h1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C9.28391 2 8.94343 2.01156 7.87667 2.05926C6.80991 2.10697 6.0851 2.27706 5.4489 2.52419C4.78466 2.78124 4.18141 3.17415 3.67778 3.67778C3.17415 4.18141 2.78124 4.78466 2.52419 5.4489C2.27676 6.0851 2.10786 6.81198 2.05926 7.87667C2.01067 8.94136 2 9.28391 2 12C2 14.7161 2.01156 15.0566 2.05926 16.1233C2.10697 17.1901 2.27676 17.9149 2.52419 18.5511C2.78124 19.2153 3.17415 19.8186 3.67778 20.3222C4.18141 20.8258 4.78466 21.2188 5.4489 21.4758C6.0851 21.7229 6.81198 21.8921 7.87667 21.9407C8.94136 21.9893 9.28391 22 12 22C14.7161 22 15.0566 21.9884 16.1233 21.9407C17.1901 21.893 17.9149 21.7229 18.5511 21.4758C19.2153 21.2188 19.8186 20.8258 20.3222 20.3222C20.8258 19.8186 21.2188 19.2153 21.4758 18.5511C21.7229 17.9149 21.8907 17.188 21.9407 16.1233C21.9908 15.0586 22 14.7161 22 12C22 9.28391 21.9884 8.94343 21.9407 7.87667C21.893 6.80991 21.7229 6.0851 21.4758 5.4489C21.2188 4.78466 20.8258 4.18141 20.3222 3.67778C19.8186 3.17415 19.2153 2.78124 18.5511 2.52419C17.9149 2.27706 17.188 2.10786 16.1233 2.05926C15.0586 2.01067 14.7161 2 12 2ZM12 3.80194C14.6705 3.80194 14.9866 3.81231 16.0412 3.8612C17.0164 3.90565 17.5457 4.06863 17.8983 4.20553C18.365 4.38688 18.6984 4.60379 19.048 4.95374C19.3977 5.3037 19.6155 5.63588 19.7962 6.10407C19.9331 6.45669 20.0961 6.98593 20.1406 7.96112C20.1886 9.01574 20.1998 9.33191 20.1998 12.0024C20.1998 14.6728 20.1895 14.989 20.1406 16.0436C20.0961 17.0188 19.9331 17.548 19.7962 17.9007C19.6149 18.3674 19.3983 18.7007 19.048 19.0504C18.6978 19.4001 18.3665 19.6173 17.8983 19.7986C17.5457 19.9355 17.0164 20.0985 16.0412 20.1429C14.9869 20.191 14.6705 20.2022 12 20.2022C9.32954 20.2022 9.01336 20.1918 7.95875 20.1429C6.98355 20.0985 6.45432 19.9355 6.1017 19.7986C5.63499 19.6173 5.30163 19.4007 4.95167 19.0504C4.60171 18.7002 4.38451 18.3659 4.20375 17.8992C4.06685 17.5466 3.90387 17.0173 3.85942 16.0421C3.81112 14.9875 3.80016 14.6713 3.80016 12.0009C3.80016 9.33043 3.81024 9.01425 3.85942 7.95964C3.90387 6.98444 4.06685 6.45521 4.20375 6.10259C4.3851 5.63588 4.60171 5.30252 4.95167 4.95286C5.30163 4.60319 5.63499 4.3854 6.10318 4.20464C6.4558 4.06774 6.98503 3.90476 7.96023 3.86031C9.01484 3.81231 9.33102 3.80105 12.0015 3.80105L12 3.80194ZM12 6.86532C10.9843 6.86532 9.99137 7.16652 9.14683 7.73082C8.30229 8.29513 7.64405 9.09719 7.25535 10.0356C6.86665 10.974 6.76495 12.0066 6.96311 13.0028C7.16127 13.999 7.65038 14.9141 8.3686 15.6323C9.08683 16.3505 10.0019 16.8396 10.9981 17.0378C11.9943 17.2359 13.0269 17.1342 13.9653 16.7455C14.9037 16.3568 15.7058 15.6986 16.2701 14.8541C16.8344 14.0095 17.1356 13.0166 17.1356 12.0009C17.1356 10.6389 16.5945 9.3326 15.6314 8.36949C14.6683 7.40639 13.362 6.86532 12 6.86532ZM12 15.3345C11.3407 15.3345 10.6961 15.139 10.1479 14.7727C9.59972 14.4064 9.17244 13.8858 8.92013 13.2766C8.66781 12.6675 8.6018 11.9972 8.73043 11.3505C8.85905 10.7039 9.17655 10.1099 9.64277 9.64366C10.109 9.17744 10.703 8.85994 11.3496 8.73131C11.9963 8.60269 12.6666 8.6687 13.2757 8.92102C13.8849 9.17333 14.4055 9.60061 14.7718 10.1488C15.1381 10.697 15.3336 11.3416 15.3336 12.0009C15.3336 12.885 14.9824 13.7329 14.3572 14.3581C13.7321 14.9833 12.8841 15.3345 12 15.3345ZM18.5387 6.66234C18.5387 6.8997 18.4683 7.13173 18.3364 7.32908C18.2045 7.52644 18.0171 7.68026 17.7978 7.77109C17.5785 7.86193 17.3372 7.88569 17.1044 7.83939C16.8716 7.79308 16.6578 7.67878 16.4899 7.51094C16.3221 7.34311 16.2078 7.12927 16.1615 6.89647C16.1152 6.66367 16.139 6.42237 16.2298 6.20308C16.3206 5.98379 16.4745 5.79636 16.6718 5.66449C16.8692 5.53262 17.1012 5.46223 17.3386 5.46223C17.6568 5.46223 17.9621 5.58867 18.1872 5.81374C18.4122 6.0388 18.5387 6.34405 18.5387 6.66234Z",
    fill: "currentColor"
  }
) }), l1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M19.4665 7.51832C19.4678 7.62144 19.4702 7.77074 19.4729 7.94839C19.4832 8.60702 19.4994 9.65518 19.4965 10.183C19.008 10.1765 18.5216 10.1162 18.0462 10.0033L18.0462 10.0033L18.0442 10.0028C17.2116 9.81304 16.4199 9.47541 15.7066 9.00603C15.7066 9.00598 15.7065 9.00593 15.7065 9.00588C15.7061 9.00549 15.7055 9.00489 15.7047 9.00411C15.6987 8.99785 15.6814 8.98001 15.6634 8.96506C15.6418 8.94701 15.6016 8.91748 15.5445 8.90319C15.4809 8.88729 15.4169 8.89523 15.3602 8.92137C15.2995 8.9494 15.2515 8.99676 15.2238 9.05748C15.1993 9.11133 15.1971 9.16174 15.1977 9.19077C15.1982 9.21755 15.2019 9.24322 15.2035 9.25502C15.2036 9.25592 15.2038 9.25674 15.2039 9.25747C15.2048 9.26408 15.2052 9.2677 15.2054 9.26927C15.2054 9.93292 15.2066 10.5971 15.2077 11.2616C15.21 12.5943 15.2123 13.9286 15.2054 15.2636L15.2054 15.2668C15.2174 16.5793 14.749 17.8508 13.8886 18.8419L13.8875 18.8431C13.084 19.7823 11.9887 20.4248 10.7769 20.6681C9.56508 20.9114 8.30669 20.7414 7.2029 20.1852L7.20104 20.1843C7.04881 20.1094 6.90371 20.0207 6.76754 19.9195L6.63375 19.8014L6.61333 19.7834L6.58919 19.7708C6.4992 19.7239 6.41567 19.6655 6.34069 19.5971L6.33404 19.591L6.32693 19.5855C5.73511 19.1269 5.24473 18.5506 4.88671 17.893C4.52869 17.2355 4.3108 16.5109 4.24676 15.7649L4.24665 15.7637C4.22084 15.4808 4.21684 15.1964 4.2347 14.913C4.28391 14.1704 4.48436 13.4457 4.82377 12.7834C5.16323 12.121 5.63451 11.5349 6.20868 11.0613C6.78285 10.5876 7.44779 10.2363 8.16266 10.0289C8.8404 9.83236 9.54947 9.76908 10.2506 9.84222V9.84335V9.84456V9.84577V9.84698V9.84819V9.84941V9.85062V9.85183V9.85304V9.85426V9.85547V9.85668V9.85789V9.8591V9.86032V9.86153V9.86274V9.86395V9.86516V9.86638V9.86759V9.8688V9.87001V9.87123V9.87244V9.87365V9.87486V9.87607V9.87729V9.8785V9.87971V9.88092V9.88214V9.88335V9.88456V9.88577V9.88698V9.8882V9.88941V9.89062V9.89183V9.89305V9.89426V9.89547V9.89668V9.89789V9.89911V9.90032V9.90153V9.90274V9.90395V9.90517V9.90638V9.90759V9.9088V9.91002V9.91123V9.91244V9.91365V9.91486V9.91608V9.91729V9.9185V9.91971V9.92093V9.92214V9.92335V9.92456V9.92577V9.92699V9.9282V9.92941V9.93062V9.93184V9.93305V9.93426V9.93547V9.93668V9.9379V9.93911V9.94032V9.94153V9.94275V9.94396V9.94517V9.94638V9.94759V9.94881V9.95002V9.95123V9.95244V9.95365V9.95487V9.95608V9.95729V9.9585V9.95972V9.96093V9.96214V9.96335V9.96456V9.96578V9.96699V9.9682V9.96941V9.97063V9.97184V9.97305V9.97426V9.97547V9.97669V9.9779V9.97911V9.98032V9.98154V9.98275V9.98396V9.98517V9.98638V9.9876V9.98881V9.99002V9.99123V9.99244V9.99366V9.99487V9.99608V9.99729V9.99851V9.99972V10.0009V10.0021V10.0034V10.0046V10.0058V10.007V10.0082V10.0094V10.0106V10.0118V10.0131V10.0143V10.0155V10.0167V10.0179V10.0191V10.0203V10.0215V10.0227V10.024V10.0252V10.0264V10.0276V10.0288V10.03V10.0312V10.0324V10.0337V10.0349V10.0361V10.0373V10.0385V10.0397V10.0409V10.0421V10.0434V10.0446V10.0458V10.047V10.0482V10.0494V10.0506V10.0518V10.0531V10.0543V10.0555V10.0567V10.0579V10.0591V10.0603V10.0615V10.0628V10.064V10.0652V10.0664V10.0676V10.0688V10.07V10.0712V10.0724V10.0737V10.0749V10.0761V10.0773V10.0785V10.0797V10.0809V10.0821V10.0834V10.0846V10.0858V10.087V10.0882V10.0894V10.0906V10.0918V10.0931V10.0943V10.0955V10.0967V10.0979V10.0991V10.1003V10.1015V10.1028V10.104V10.1052V10.1064V10.1076V10.1088V10.11V10.1112V10.1125V10.1137V10.1149V10.1161V10.1173V10.1185V10.1197V10.1209V10.1221V10.1234V10.1246V10.1258V10.127V10.1282V10.1294V10.1306V10.1318V10.1331V10.1343V10.1355V10.1367V10.1379V10.1391V10.1403V10.1415V10.1428V10.144V10.1452V10.1464V10.1476V10.1488V10.15V10.1512V10.1525V10.1537V10.1549V10.1561V10.1573V10.1585V10.1597V10.1609V10.1622V10.1634V10.1646V10.1658V10.167V10.1682V10.1694V10.1706V10.1718V10.1731V10.1743V10.1755V10.1767V10.1779V10.1791V10.1803V10.1815V10.1828V10.184V10.1852V10.1864V10.1876V10.1888V10.19V10.1912V10.1925V10.1937V10.1949V10.1961V10.1973V10.1985V10.1997V10.2009V10.2022V10.2034V10.2046V10.2058V10.207V10.2082V10.2094V10.2106V10.2119V10.2131V10.2143V10.2155V10.2167V10.2179V10.2191V10.2203V10.2215V10.2228V10.224V10.2252V10.2264V10.2276V10.2288V10.23V10.2312V10.2325V10.2337V10.2349V10.2361V10.2373V10.2385V10.2397V10.2409V10.2422V10.2434V10.2446V10.2458V10.247V10.2482V10.2494V10.2506V10.2519V10.2531V10.2543V10.2555V10.2567V10.2579V10.2591V10.2603V10.2616V10.2628V10.264V10.2652V10.2664V10.2676V10.2688V10.27V10.2712V10.2725V10.2737V10.2749V10.2761V10.2773V10.2785V10.2797V10.2809V10.2822V10.2834V10.2846V10.2858V10.287V10.2882V10.2894V10.2906V10.2919V10.2931V10.2943V10.2955V10.2967V10.2979V10.2991V10.3003V10.3016V10.3028V10.304V10.3052V10.3064V10.3076V10.3088V10.31V10.3113V10.3125V10.3137V10.3149V10.3161V10.3173V10.3185V10.3197V10.3209V10.3222V10.3234V10.3246V10.3258V10.327V10.3282V10.3294V10.3306V10.4233L10.2537 10.4264C10.2547 10.4692 10.2559 10.5264 10.2573 10.595C10.2603 10.7542 10.2641 10.9739 10.2677 11.2161C10.2743 11.6565 10.2804 12.1698 10.2815 12.5294C10.1238 12.497 9.96351 12.4777 9.8024 12.4718C9.45802 12.4514 9.11313 12.5025 8.78946 12.6219L8.78935 12.622C7.72481 13.0153 7.06037 13.8088 6.92558 14.9298C6.79077 16.0509 7.24104 16.9549 8.16244 17.5921L8.16241 17.5921L8.16611 17.5946C8.23031 17.6371 8.29229 17.6829 8.35181 17.7318L8.39888 17.773L8.42436 17.7953L8.45529 17.809C8.66448 17.9021 8.88177 17.9757 9.10442 18.0291L9.1044 18.0292L9.11119 18.0306C9.48518 18.108 9.87097 18.1089 10.2454 18.0334C10.6197 17.9579 10.975 17.8075 11.2897 17.5911C11.6045 17.3748 11.8722 17.097 12.0769 16.7746C12.2815 16.4521 12.4188 16.0916 12.4806 15.7147L12.4807 15.7141C12.5065 15.5539 12.5178 15.3916 12.5145 15.2294V3.22461H15.1805C15.1984 3.45166 15.2287 3.67758 15.2714 3.90135L15.2717 3.90252C15.4857 4.99256 16.2237 5.85359 16.9799 6.44923C17.36 6.74866 17.7509 6.986 18.0953 7.15632C18.4349 7.32421 18.7434 7.43389 18.9587 7.46705C19.1268 7.49442 19.2964 7.51153 19.4665 7.51832ZM10.4606 12.5722C10.4641 12.5729 10.4644 12.5733 10.4606 12.5722L10.4606 12.5722ZM10.2514 10.3479L10.2514 10.3479L10.2514 10.3479Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "0.447504"
  }
) }), o1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M21.5822 16.8138C21.4682 17.2376 21.2449 17.6241 20.9346 17.9344C20.6243 18.2447 20.2378 18.468 19.814 18.582C18.2542 19 12 19 12 19C12 19 5.7458 19 4.186 18.582C3.7622 18.468 3.37579 18.2447 3.06546 17.9343C2.75514 17.624 2.5318 17.2376 2.4178 16.8138C2 15.2542 2 12 2 12C2 12 2 8.7456 2.4178 7.1862C2.53178 6.76237 2.75512 6.37593 3.06544 6.06557C3.37577 5.75521 3.76218 5.53183 4.186 5.4178C5.7458 5 12 5 12 5C12 5 18.2542 5 19.814 5.4178C20.2378 5.53181 20.6243 5.75519 20.9346 6.06555C21.2449 6.37591 21.4682 6.76236 21.5822 7.1862C22 8.7456 22 12 22 12C22 12 22 15.2544 21.5822 16.814V16.8138ZM10 9V15L15.196 12L10 9Z",
    fill: "currentColor"
  }
) }), d1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fill: "currentColor",
    d: "M7.86 7.704V18.5H4.214V7.704H7.86zm.24-3.34c0 1.037-.792 1.867-2.063 1.867h-.023C4.791 6.23 4 5.4 4 4.365 4 3.306 4.815 2.5 6.061 2.5c1.247 0 2.015.806 2.038 1.865zM21 12.31v6.19h-3.644v-5.776c0-1.45-.527-2.44-1.846-2.44-1.007 0-1.606.667-1.87 1.311-.096.231-.12.553-.12.876V18.5H9.876s.048-9.783 0-10.796h3.644v1.53c.484-.735 1.35-1.783 3.285-1.783C19.202 7.45 21 8.994 21 12.31z"
  }
) }), n1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...i, children: /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M19 12.3058C19 11.8203 18.9606 11.3322 18.8767 10.8546L12.1404 10.8546V13.6048H15.9979C15.8379 14.4917 15.3235 15.2764 14.5704 15.775V17.5594H16.8718C18.2232 16.3155 19 14.4786 19 12.3058Z",
      fill: "#4285F4"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M12.1404 19.2833C14.0665 19.2833 15.6909 18.6509 16.8744 17.5592L14.573 15.7748C13.9327 16.2104 13.1061 16.4571 12.143 16.4571C10.2798 16.4571 8.70009 15.2001 8.13327 13.5101H5.75839V15.3497C6.97076 17.7613 9.44011 19.2833 12.1404 19.2833Z",
      fill: "#34A853"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M8.13065 13.5102C7.83149 12.6233 7.83149 11.6628 8.13065 10.7758V8.93628H5.75839C4.74545 10.9543 4.74545 13.3318 5.75839 15.3498L8.13065 13.5102Z",
      fill: "#FBBC04"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M12.1404 7.82623C13.1586 7.81049 14.1426 8.19362 14.88 8.8969L16.919 6.85791C15.6279 5.64554 13.9143 4.979 12.1404 4.99999C9.44011 4.99999 6.97076 6.52202 5.75839 8.93626L8.13065 10.7758C8.69485 9.08322 10.2772 7.82623 12.1404 7.82623Z",
      fill: "#EA4335"
    }
  )
] }) }), s1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6C3.44772 6 3 6.44772 3 7L3 18C3 18.5523 3.44772 19 4 19L20 19C20.5523 19 21 18.5523 21 18L21 7C21 6.44772 20.5523 6 20 6L4 6ZM5 10.2296L5 17H19V10.2296L12.5215 14.5252C12.2013 14.7209 11.7987 14.7209 11.4785 14.5252L5 10.2296ZM18.75 8L5.25 8L12 12.5L18.75 8Z",
    fill: "currentColor"
  }
) }), r1 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "#9FA6BB",
        fillRule: "evenodd",
        d: "M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8Zm13.64-.6H6.36c.031.018.06.039.088.062l4.72 3.933a1.3 1.3 0 0 0 1.664 0l4.72-3.933a.696.696 0 0 1 .087-.062ZM5.4 8.36V16a.6.6 0 0 0 .6.6h12a.6.6 0 0 0 .6-.6V8.36a.699.699 0 0 1-.152.178l-4.72 3.933a2.7 2.7 0 0 1-3.457 0l-4.72-3.933A.7.7 0 0 1 5.4 8.36Z",
        clipRule: "evenodd"
      }
    )
  }
), a1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M7.5 4.85a1 1 0 0 0-1.5.87v12.56a1 1 0 0 0 1.5.87l10.98-6.28a1 1 0 0 0 0-1.74L7.5 4.85Z" }) }), L1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fill: "#1DA1F2",
    d: "M22 6.657a7.644 7.644 0 0 1-2.121.557 3.577 3.577 0 0 0 1.624-1.956c-.714.405-1.504.7-2.345.858A3.767 3.767 0 0 0 16.462 5c-2.04 0-3.693 1.582-3.693 3.534 0 .277.033.547.096.806-3.07-.148-5.79-1.555-7.612-3.693-.318.522-.5 1.129-.5 1.777 0 1.226.652 2.308 1.643 2.942a3.804 3.804 0 0 1-1.673-.443v.045c0 1.712 1.273 3.14 2.962 3.465a3.856 3.856 0 0 1-1.667.061c.47 1.404 1.833 2.426 3.45 2.454a7.623 7.623 0 0 1-4.587 1.513c-.298 0-.592-.016-.881-.049A10.795 10.795 0 0 0 9.66 19c6.793 0 10.508-5.386 10.508-10.056a9.82 9.82 0 0 0-.01-.457A7.332 7.332 0 0 0 22 6.657z"
  }
) }), c1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M10 13.762l-3.754 2.169a.515.515 0 0 1-.695-.172.481.481 0 0 1-.058-.36l.96-4.144-3.28-2.803a.484.484 0 0 1-.047-.695.512.512 0 0 1 .334-.166L7.808 7.2l1.727-3.9a.512.512 0 0 1 .93 0l1.727 3.9 4.348.392a.497.497 0 0 1 .458.537.489.489 0 0 1-.17.324l-3.28 2.803.96 4.144a.493.493 0 0 1-.384.589.519.519 0 0 1-.37-.057L10 13.762z" }) }), v1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M12.2698261,15.8318852 C15.0312499,15.8318852 17.2698261,13.5933089 17.2698261,10.8318852 C17.2698261,8.07046142 15.0312499,5.83188517 12.2698261,5.83188517 C9.50840238,5.83188517 7.26982613,8.07046142 7.26982613,10.8318852 C7.26982613,13.5933089 9.50840238,15.8318852 12.2698261,15.8318852 Z M11.2702413,17.7610557 C7.87774473,17.2760047 5.26982613,14.3585009 5.26982613,10.8318852 C5.26982613,6.96589192 8.40383288,3.83188517 12.2698261,3.83188517 C16.1358194,3.83188517 19.2698261,6.96589192 19.2698261,10.8318852 C19.2698261,14.3582132 16.662333,17.2755287 13.2702412,17.7609369 L13.2720045,21.7077671 L11.2720045,21.7077671 L11.2702413,17.7610557 Z",
    transform: "rotate(-45 12.27 12.77)"
  }
) }), V1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M10.8,12 L10.8,4.8 L20.4,4.8 L20.4,19.2 L4.8,19.2 L4.8,12 L10.8,12 Z M13.2,7.2 L13.2,9.6 L18,9.6 L18,7.2 L13.2,7.2 Z M13.2,10.8 L13.2,13.2 L18,13.2 L18,10.8 L13.2,10.8 Z M13.2,14.4 L13.2,16.8 L18,16.8 L18,14.4 L13.2,14.4 Z M7.2,14.4 L7.2,16.8 L10.8,16.8 L10.8,14.4 L7.2,14.4 Z" }) }), w1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M15.6,6 L19.2,6 L19.2,19.2 L4.8,19.2 L4.8,6 L8.4,6 L8.4,4.2 L10.8,4.2 L10.8,6 L13.2,6 L13.2,4.2 L15.6,4.2 L15.6,6 Z M7.2,9.6 L7.2,16.8 L16.8,16.8 L16.8,9.6 L7.2,9.6 Z M8.4,14.4 L8.4,12 L10.8,12 L10.8,14.4 L8.4,14.4 Z M13.2,14.4 L13.2,12 L15.6,12 L15.6,14.4 L13.2,14.4 Z" }) }), g1 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 7V18H18.5V7H12.5H6.5ZM5.5 5C4.94772 5 4.5 5.44772 4.5 6V19C4.5 19.5523 4.94772 20 5.5 20H19.5C20.0523 20 20.5 19.5523 20.5 19V6C20.5 5.44772 20.0523 5 19.5 5H5.5Z"
    }
  ),
  /* @__PURE__ */ e("path", { d: "M5.5 10H19.5", stroke: "currentColor", strokeWidth: "2" }),
  /* @__PURE__ */ e("path", { d: "M9.5 8L9.5 4", stroke: "currentColor", strokeWidth: "2" }),
  /* @__PURE__ */ e("path", { d: "M15.5 8L15.5 4", stroke: "currentColor", strokeWidth: "2" })
] }), p1 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.407 4.43a.7.7 0 0 0-.814 0l-7 5a.7.7 0 1 0 .814 1.14L12 5.86l6.593 4.71a.7.7 0 0 0 .814-1.14l-7-5ZM7.7 12a.7.7 0 1 0-1.4 0v6a.7.7 0 0 0 .7.7h10a.7.7 0 0 0 .7-.7v-6a.7.7 0 1 0-1.4 0v5.3H7.7V12Z"
      }
    )
  }
), M1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 10C18.5 12.4318 16.9395 14.9523 15.0208 17.0607C14.1115 18.06 13.196 18.8854 12.5 19.4658C11.804 18.8854 10.8885 18.06 9.97918 17.0607C8.06045 14.9523 6.5 12.4318 6.5 10C6.5 6.68629 9.18629 4 12.5 4C15.8137 4 18.5 6.68629 18.5 10ZM20.5 10C20.5 16.4183 12.5 22 12.5 22C12.5 22 4.5 16.4183 4.5 10C4.5 5.58172 8.08172 2 12.5 2C16.9183 2 20.5 5.58172 20.5 10ZM13.5 10C13.5 10.5523 13.0523 11 12.5 11C11.9477 11 11.5 10.5523 11.5 10C11.5 9.44772 11.9477 9 12.5 9C13.0523 9 13.5 9.44772 13.5 10ZM15.5 10C15.5 11.6569 14.1569 13 12.5 13C10.8431 13 9.5 11.6569 9.5 10C9.5 8.34315 10.8431 7 12.5 7C14.1569 7 15.5 8.34315 15.5 10Z"
  }
) }), f1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M11.8000058,11.4 C11.9298279,11.5730962 12.0000058,11.7836298 12.0000058,12 L12.0000058,15.382 L13.0000058,14.882 L13.0000058,12 C13.0000058,11.7836298 13.0701836,11.5730962 13.2000058,11.4 L17.0000058,6 L8.00000576,6 L11.8000058,11.4 Z M5.20000576,5.6 C4.97274253,5.29698235 4.93618656,4.89157043 5.10557857,4.5527864 C5.27497059,4.21400238 5.6212337,4 6.00000576,4 L19.0000058,4 C19.3787778,4 19.7250409,4.21400238 19.894433,4.5527864 C20.063825,4.89157043 20.027269,5.29698235 19.8000058,5.6 L15.0000058,12.333 L15.0000058,15.5 C14.9998035,15.8786657 14.7857352,16.2247365 14.4470058,16.394 L11.4470058,17.894 C11.1371033,18.0488588 10.7691266,18.0322854 10.4744001,17.8501945 C10.1796736,17.6681037 10.0001907,17.3464401 10.0000058,17 L10.0000058,12.333 L5.20000576,5.6 Z" }) }), Z1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M13 14v5h-2v-5H7v5h10v-5h-4zm0-2h5v-2H6v2h5v-2h2v2zm4.965-4H19a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1.035A3.5 3.5 0 0 1 12 5.05 3.5 3.5 0 0 1 17.965 8zm-4.88 0h2.83a1.5 1.5 0 1 0-2.83 0zm-5 0h2.83a1.5 1.5 0 1 0-2.83 0z" }) }), u1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M1 4h22v3H1V4zm0 7h22v3H1v-3zm0 7h22v3H1v-3z" }) }), x1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M12 9.879l6.718-6.718 2.121 2.121L14.121 12l6.718 6.718-2.121 2.121L12 14.121l-6.718 6.718-2.121-2.121L9.879 12 3.161 5.282l2.121-2.121z" }) }), H1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M8,11 C8,7.83333333 9.375,6 12,6 C14.625,6 16,7.83333333 16,11 C16.5522847,11 17,11.4477153 17,12 L17,17 C17,17.5522847 16.5522847,18 16,18 L8,18 C7.44771525,18 7,17.5522847 7,17 L7,12 C7,11.4477153 7.44771525,11 8,11 Z M10,11 L14,11 C14,8.83333333 13.375,8 12,8 C10.625,8 10,8.83333333 10,11 Z" }) }), k1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M6,4 L14.9793444,4 C15.3056582,4 15.6114477,4.15921098 15.7985764,4.42653766 L18.8192319,8.74175989 C18.9368904,8.90984342 19,9.11005013 19,9.31522223 L19,20 C19,20.5522847 18.5522847,21 18,21 L6,21 C5.44771525,21 5,20.5522847 5,20 L5,5 C5,4.44771525 5.44771525,4 6,4 Z M7,6 L7,19 L17,19 L17,9.63044446 L14.4586889,6 L7,6 Z M9,11 L15,11 L15,13 L9,13 L9,11 Z M9,14 L15,14 L15,16 L9,16 L9,14 Z" }) }), B1 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e("path", { d: "M17,12 C17,9.23857625 14.7614237,7 12,7 C9.23857625,7 7,9.23857625 7,12 C7,14.7614237 9.23857625,17 12,17 C12.5522847,17 13,17.4477153 13,18 C13,18.5522847 12.5522847,19 12,19 C8.13400675,19 5,15.8659932 5,12 C5,8.13400675 8.13400675,5 12,5 C15.8659932,5 19,8.13400675 19,12 C19,12.5522847 18.5522847,13 18,13 C17.4477153,13 17,12.5522847 17,12 Z" })
  }
), m1 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19",
      stroke: "url(#paint0_angular_13868_15969)",
      strokeWidth: "1.8",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ t(
    "radialGradient",
    {
      id: "paint0_angular_13868_15969",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(12 12) rotate(90) scale(7)",
      children: [
        /* @__PURE__ */ e("stop", { offset: "0.764601" }),
        /* @__PURE__ */ e("stop", { offset: "0.978601", stopOpacity: "0" })
      ]
    }
  ) })
] }), R1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M7 7h10v10H7V7zm5 3l-3 4h6l-3-4z" }) }), F1 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  "(",
  /* @__PURE__ */ e("path", { d: "M15 16h4l-4.5-8-3.192 4.643L9.5 11 5 16h10zM2 2h20v20H2V2z" })
] }), _1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M22.8,12 C22.8,6.04041451 17.9595855,1.2 12,1.2 C6.04041451,1.2 1.2,6.04041451 1.2,12 C1.2,17.9595855 6.04041451,22.8 12,22.8 C17.9595855,22.8 22.8,17.9595855 22.8,12 Z M11.9440415,8.81036269 C11.6642487,8.78238342 11.384456,8.89430052 11.1606218,9.09015544 C10.9647668,9.28601036 10.92,9.56580311 10.92,9.84559585 L8.76,9.84559585 C8.76,8.92227979 8.83834197,8.02694301 9.50984456,7.38341969 C10.1813472,6.73989637 11.0766839,6.40414508 12.0279793,6.43212435 C13.7626943,6.51606218 15.1896373,7.94300518 15.2735751,9.67772021 C15.3295337,11.1326425 14.4901554,12.4756477 13.119171,13.0072539 C13.0911917,13.0352332 13.0352332,13.0911917 13.0352332,13.1751295 L13.0352332,14.16 L10.6569948,14.16 L10.6569948,13.1751295 C10.6569948,12.1119171 11.2725389,11.188601 12.2238342,10.8248705 C12.6435233,10.6569948 12.8953368,10.2373057 12.8673575,9.78963731 C12.8953368,9.28601036 12.4476684,8.83834197 11.9440415,8.81036269 Z M12,17.94 C11.2544156,17.94 10.65,17.3355844 10.65,16.59 C10.65,15.8444156 11.2544156,15.24 12,15.24 C12.7455844,15.24 13.35,15.8444156 13.35,16.59 C13.35,17.3355844 12.7455844,17.94 12,17.94 Z" }) }), A1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-1.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5zm3.69-13.47c0 2.73-2.827 2.73-2.827 5.558H10.62c0-3.608 2.73-3.608 2.73-5.363 0-.877-.585-1.462-1.56-1.462-.877 0-1.56.682-1.56 1.852H7.89c.098-2.438 1.657-3.998 3.9-3.998 2.438 0 3.9 1.463 3.9 3.413zm-5.167 7.8a1.29 1.29 0 0 1 1.267-1.267 1.29 1.29 0 0 1 1.268 1.267 1.29 1.29 0 0 1-1.268 1.268 1.29 1.29 0 0 1-1.267-1.268z" }) }), z1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M10.4726494,12 L7.45632468,15.0163247 L8.98367532,16.5436753 L12,13.5273506 L15.0163247,16.5436753 L16.5436753,15.0163247 L13.5273506,12 L16.5436753,8.98367532 L15.0163247,7.45632468 L12,10.4726494 L8.98367532,7.45632468 L7.45632468,8.98367532 L10.4726494,12 Z M22.8,12 C22.8,17.9595855 17.9595855,22.8 12,22.8 C6.04041451,22.8 1.2,17.9595855 1.2,12 C1.2,6.04041451 6.04041451,1.2 12,1.2 C17.9595855,1.2 22.8,6.04041451 22.8,12 Z" }) }), b1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M4.617 15.365c-.398-.5-.753-1.04-1.056-1.614-.107-.2-.238-.486-.396-.856a1 1 0 0 1 .002-.789c.208-.48.383-.845.524-1.096C5.38 8.01 8.467 6 12 6c1.5 0 2.92.362 4.187 1.01L13.899 8.66A3.89 3.89 0 0 0 12 8.167c-2.258 0-4.09 1.941-4.09 4.333 0 .159.007.316.023.47l-3.316 2.395zm3.196 2.626l2.288-1.652a3.89 3.89 0 0 0 1.899.494c2.258 0 4.09-1.941 4.09-4.333 0-.159-.007-.316-.023-.47l3.316-2.395c.324.406.62.84.881 1.296.154.267.342.658.567 1.173a1 1 0 0 1 .003.793c-.169.394-.31.696-.423.908C18.747 16.907 15.605 19 12 19c-1.5 0-2.92-.362-4.187-1.01zm4.362-8.085l-2.52 1.82C9.965 10.666 10.896 9.9 12 9.9c.059 0 .117.002.175.006zm2.17 3.368c-.31 1.06-1.241 1.826-2.345 1.826-.059 0-.117-.002-.175-.006l2.52-1.82zM3.585 19.81l-1.17-1.622 18-13 1.17 1.622-18 13z" }) }), W1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M5.84757 13.8042C5.5156 13.3882 5.22039 12.938 4.96725 12.4595C4.87867 12.2921 4.76876 12.0543 4.63751 11.7462C4.54794 11.5359 4.54866 11.2981 4.6395 11.0884L4.63948 11.0884C4.81271 10.6884 4.95817 10.3839 5.07588 10.1748C6.48263 7.67541 9.05568 6 12 6C13.2502 6 14.4334 6.30207 15.4889 6.84102L13.5825 8.21783C13.1095 7.95455 12.5711 7.80555 12 7.80555C10.1182 7.80555 8.5909 9.42333 8.5909 11.4167C8.5909 11.5491 8.59764 11.6798 8.61077 11.8085L5.84757 13.8042ZM8.5111 15.9923L10.4174 14.6155C10.8905 14.8788 11.4289 15.0278 12 15.0278C13.8818 15.0278 15.4091 13.41 15.4091 11.4167C15.4091 11.2843 15.4023 11.1535 15.3892 11.0248L18.1524 9.02913C18.4226 9.36772 18.6684 9.72888 18.887 10.1095C19.0146 10.3318 19.172 10.6576 19.3591 11.087C19.4508 11.2975 19.4516 11.5364 19.3613 11.7475L19.3614 11.7475C19.2211 12.0755 19.1036 12.3278 19.0088 12.5044C17.6223 15.0888 15.0044 16.8333 12 16.8333C10.7498 16.8333 9.56655 16.5313 8.5111 15.9923ZM12.1459 9.2554L10.0462 10.7718C10.3046 9.88903 11.0803 9.25 12 9.25C12.0491 9.25 12.0977 9.25182 12.1459 9.2554ZM13.9538 12.0615C13.6953 12.9443 12.9197 13.5833 12 13.5833C11.9509 13.5833 11.9023 13.5815 11.8541 13.5779L13.9538 12.0615ZM4.9879 17.5089L4.01208 16.1578L19.0121 5.32443L19.9879 6.67556L4.9879 17.5089Z" }) }), y1 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.0001 6c-.5523 0-1 .4477-1 1v11c0 .5523.4477 1 1 1h16c.5523 0 1-.4477 1-1V7c0-.5523-.4477-1-1-1h-16zm1 4.2296V17h14v-6.7704l-6.4785 4.2956a.9997.9997 0 0 1-1.0429 0l-6.4786-4.2956zM18.7501 8h-13.5l6.75 4.5 6.75-4.5z"
      }
    )
  }
), E1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M6.5,14 C5.67157288,14 5,13.3284271 5,12.5 C5,11.6715729 5.67157288,11 6.5,11 C7.32842712,11 8,11.6715729 8,12.5 C8,13.3284271 7.32842712,14 6.5,14 Z M12.5,14 C11.6715729,14 11,13.3284271 11,12.5 C11,11.6715729 11.6715729,11 12.5,11 C13.3284271,11 14,11.6715729 14,12.5 C14,13.3284271 13.3284271,14 12.5,14 Z M18.5,14 C17.6715729,14 17,13.3284271 17,12.5 C17,11.6715729 17.6715729,11 18.5,11 C19.3284271,11 20,11.6715729 20,12.5 C20,13.3284271 19.3284271,14 18.5,14 Z" }) }), S1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10c0 2.432-1.56 4.952-3.48 7.06-.909 1-1.824 1.825-2.52 2.406a25.76 25.76 0 01-2.52-2.405C7.56 14.952 6 12.43 6 10a6 6 0 1112 0zm2 0c0 6.418-8 12-8 12s-8-5.582-8-12a8 8 0 1116 0zm-7 0a1 1 0 11-2 0 1 1 0 012 0zm2 0a3 3 0 11-6 0 3 3 0 016 0z"
  }
) }), j1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M4.01470461,16.8420411 L4.01470461,8.66856283 C3.91571585,7.88952094 4.31650779,7.5 5.21708044,7.5 C6.11765308,7.5 7.2385336,7.5 8.57972199,7.5 L8.57972199,5.63333333 C8.66429615,4.54444444 9.42156837,4 10.8515386,4 C11.4895067,4 12.247873,4 13.1382211,4 C14.5894015,4 15.3539574,4.54444444 15.4318888,5.63333333 L15.4318888,7.5 C17.0529266,7.5 18.2195379,7.5 18.9317228,7.5 C19.6439076,7.5 20,7.88952094 20,8.66856283 L20,16.8420411 C20,17.6140137 19.6439076,18 18.9317228,18 C18.2500168,18 6.31912268,18 5.21708044,18 C4.41549655,18 4.01470461,17.6140137 4.01470461,16.8420411 Z M10.22,6 L10.22,7.5 L13.82,7.5 L13.8173374,6 L10.22,6 Z" }) }), D1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M5 13L9.5 17.5L19 8" }) }), U1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M17 19V7.87116L14.1643 5H7v14h10zm1 2H6c-.55228 0-1-.4477-1-1V4c0-.55228.44772-1 1-1h8.5821c.2674 0 .5236.10707.7115.2973l3.4179 3.46058c.1848.18717.2885.43963.2885.7027V20c0 .5523-.4477 1-1 1z M15 10H9v2h2v4h2v-4h2v-2z" }) }), T1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("path", { d: "M17 19V7.82843L14.1716 5H7v14h10zm1 2H6c-.55228 0-1-.4477-1-1V4c0-.55228.44772-1 1-1h8.5858c.2652 0 .5196.10536.7071.29289l3.4142 3.41422c.1875.18753.2929.44189.2929.7071V20c0 .5523-.4477 1-1 1z M10.5169 12.8175L9.66292 10H8l1.75281 5h1.30339L12 12.2222 12.9438 15h1.3034L16 10h-1.6629l-.854 2.8175L12.5393 10h-1.0786l-.9438 2.8175z" }) }), O1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15H8V19C8 19.5523 8.44771 20 9 20H19C19.5523 20 20 19.5523 20 19V9C20 8.44772 19.5523 8 19 8H15V4C15 3.44772 14.5523 3 14 3H4C3.44772 3 3 3.44772 3 4V14C3 14.5523 3.44772 15 4 15ZM5 5V13H8V9C8 8.44771 8.44772 8 9 8H13V5H5ZM13 13V11H15V13H17V15H15V17H13V15H11V13H13ZM10 10H18V18H10V10Z"
  }
) }), I1 = () => /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 16.6c-.5.2-1.1.4-1.7.4a3.5 3.5 0 113-1.8l1.7 1.6-1.4 1.4-1.6-1.6zm-.2-3.1a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z M7 6V4c0-1.1.9-2 2-2h6a2 2 0 012 2v2h3a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V8c0-1.1.9-2 2-2h3zm2-2h6v2H9V4zM4 8v12h16V8H4z"
  }
) }), G1 = () => /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0z",
      fill: "#4F5259"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 13V8h2v5h-2zm2.25 2.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
      fill: "#fff"
    }
  )
] }), P1 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-3.5-1.5-1.4-1.4-3.5 3.9-2.2-2L8 12.6l2.9 2.6c.4.5.9.5 1.4 0l4.2-4.6Z"
  }
) }), N1 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.097 9.07098L16.5 10.5L12.254 15.113C11.776 15.638 11.348 15.62 10.851 15.113L8 12.5L9.403 11.071L11.553 12.971L15.097 9.07098Z",
      fill: "#fff"
    }
  )
] }), J1 = () => /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e("path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", fill: "#98A1B3" }),
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m12 10.6 1.8-1.8 1.4 1.4-1.8 1.8 1.8 1.8-1.4 1.4-1.8-1.8-1.8 1.8-1.4-1.4 1.8-1.8-1.8-1.8 1.4-1.4 1.8 1.8Z",
      fill: "#fff"
    }
  )
] }), Q1 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
          fill: "#FB4458"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9999 10.5861L13.7676 8.81836L15.1818 10.2326L13.4141 12.0003L15.1818 13.7681L13.7676 15.1823L11.9999 13.4146L10.2321 15.1823L8.81787 13.7681L10.5856 12.0003L8.81787 10.2326L10.2321 8.81836L11.9999 10.5861Z",
          fill: "white"
        }
      )
    ]
  }
), Y1 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
          fill: "#FB4458"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11 13V8H13V13H11ZM13.25 15.75C13.25 16.4404 12.6904 17 12 17C11.3096 17 10.75 16.4404 10.75 15.75C10.75 15.0596 11.3096 14.5 12 14.5C12.6904 14.5 13.25 15.0596 13.25 15.75Z",
          fill: "white"
        }
      )
    ]
  }
), q1 = () => /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e("path", { d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24Z", fill: "#FFC1A9" }),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M9 19a3.4 3.4 0 0 1 2-2 3.5 3.5 0 0 1 4 2M10 9l-2 4 3 1.6M14 9c.3 1.6 2.1 2 3 2 .9 0 2 0 3-2M3.7 9A3.6 3.6 0 0 0 7 11c1 0 2.3-1 3-2",
      fill: "transparent",
      stroke: "#823C21",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), K1 = () => /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e("path", { d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24Z", fill: "#FFDB80" }),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M4 9h6M14 9h5M10 9l-2 4 3 1.4M9 17l8 1",
      fill: "transparent",
      stroke: "#523D1D",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), X1 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.9 6.99998C9.9 6.39246 10.3925 5.89998 11 5.89998H13C13.6075 5.89998 14.1 6.39246 14.1 6.99998C14.1 6.99999 14.1 7 14.1 7.00001H6C4.89543 7.00001 4 7.89544 4 9.00001V10.72V11.62V12.52V16C4 17.1046 4.89543 18 6 18H18C19.1046 18 20 17.1046 20 16V12.52V11.62V10.72V9.00001C20 7.89544 19.1046 7.00001 18 7.00001H15.9C15.9 7 15.9 6.99999 15.9 6.99998C15.9 5.39835 14.6016 4.09998 13 4.09998H11C9.39837 4.09998 8.1 5.39835 8.1 6.99998H9.9ZM18.2 10.72H5.8V9.00001C5.8 8.88956 5.88954 8.80001 6 8.80001H18C18.1105 8.80001 18.2 8.88956 18.2 9.00001V10.72ZM18.2 16V12.52H5.8V16C5.8 16.1105 5.88954 16.2 6 16.2H18C18.1105 16.2 18.2 16.1105 18.2 16Z",
        fill: "#0F141E"
      }
    )
  }
), $1 = () => /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e("path", { d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24Z", fill: "#95D9B2" }),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M4.8 6.7C5 6.5 6.5 4.8 8 5.5 9 6 9.6 6.8 10 9M8 16.5s1.9 2.4 3.9 2.5a5.2 5.2 0 0 0 5.1-4.4c-7.1.2-9 1.9-9 1.9ZM14.4 8.2c.2-.2 1.5-1.7 3.1-1.3a3.1 3.1 0 0 1 2.2 2.6M10 9l-2 3 4 3",
      stroke: "#293F24",
      fill: "transparent",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), e2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.5182 4.35212C16.876 4.00709 17.4458 4.01745 17.7908 4.37525L20.648 7.33822C20.9841 7.68686 20.9841 8.23902 20.648 8.58766L17.7908 11.5506C17.4458 11.9084 16.876 11.9188 16.5182 11.5738C16.1604 11.2287 16.1501 10.659 16.4951 10.3012L17.882 8.86294H14.5001C12.788 8.86294 11.4001 10.2509 11.4001 11.9629V14C11.4001 14.497 10.9972 14.9 10.5001 14.9C10.003 14.9 9.6001 14.497 9.6001 14V11.9629C9.6001 9.25674 11.7939 7.06294 14.5001 7.06294H17.882L16.4951 5.6247C16.1501 5.2669 16.1604 4.69714 16.5182 4.35212Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.1001 7.99998C5.1001 6.39835 6.39847 5.09998 8.0001 5.09998H9.0001C9.49715 5.09998 9.9001 5.50292 9.9001 5.99998C9.9001 6.49703 9.49715 6.89998 9.0001 6.89998H8.0001C7.39258 6.89998 6.9001 7.39246 6.9001 7.99998V16C6.9001 16.6075 7.39258 17.1 8.0001 17.1H16.0001C16.6076 17.1 17.1001 16.6075 17.1001 16V14.5C17.1001 14.0029 17.503 13.6 18.0001 13.6C18.4972 13.6 18.9001 14.0029 18.9001 14.5V16C18.9001 17.6016 17.6017 18.9 16.0001 18.9H8.0001C6.39847 18.9 5.1001 17.6016 5.1001 16V7.99998Z",
          fill: "white"
        }
      )
    ]
  }
), i2 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M17.1429 5L20 7.96296M20 7.96296L17.1429 10.9259M20 7.96296H14.5C12.2909 7.96296 10.5 9.75382 10.5 11.963V14",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M9 6H8C6.89543 6 6 6.89543 6 8V16C6 17.1046 6.89543 18 8 18H16C17.1046 18 18 17.1046 18 16V14.5",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), t2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.67 2a1 1 0 1 1 0-2c3.35 0 6.26 1.09 8.67 3.26C22.78 5.46 24 8.5 24 12.33a1 1 0 0 1-2 0c0-3.28-1-5.79-3-7.59A10.55 10.55 0 0 0 11.67 2Z"
  }
) }), C2 = () => /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M6 1a2 2 0 0 0-2 2v18c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V7h-4a2 2 0 0 1-2-2V1H6Z",
      fill: "#D8544E"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M12.5 10.2c0-.5-.1-.8-.2-.9a.8.8 0 0 0-.7-.3 1 1 0 0 0-.9.6v.5c0 .6.2 1.2.4 1.7-.2 1-.6 2.3-1.1 3.3-1.2.5-1.9 1-2 1.8 0 .3.1.7.5 1l.5.1c.4 0 .7-.3 1-.8l.8-1.3 2.6-.8c.5.4 1 .7 1.4.7.4 0 .8-.2 1-.5l.2-.6v-.4c-.3-.4-.7-.5-1.3-.5h-1c-.5-.5-1-1.3-1.4-2a7 7 0 0 0 .2-1.6Zm-1 4.3c0-.4.2-.9.4-1.3l.6 1-1 .3Z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e("path", { d: "m14 1 3 3 3 3h-4a2 2 0 0 1-2-2V1Z", fill: "#E39494" })
] }), h2 = () => /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 19V7.87116L14.1643 5H7V19H17ZM18 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H14.5821C14.8495 3 15.1057 3.10707 15.2936 3.2973L18.7115 6.75788C18.8963 6.94505 19 7.19751 19 7.46058V20C19 20.5523 18.5523 21 18 21Z",
      fill: "#1A91F0"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.8141 12.6739C15.3543 12.6816 15.7083 12.7657 15.8685 12.9272L15.8707 12.925C15.9281 12.9826 15.9801 13.0656 15.9887 13.1331C16.0169 13.3599 15.9952 13.5812 15.8913 13.7427C15.8382 13.8246 15.7505 13.8844 15.6477 13.9131C15.5806 13.932 15.4983 13.9408 15.402 13.9408C14.8628 13.9408 14.0098 13.6631 13.3147 13.2636C12.4043 13.403 11.365 13.6564 10.4513 13.9596C9.65994 15.3704 9.08509 16 8.59143 16C8.49941 16 8.40955 15.9779 8.32403 15.9336L8.12592 15.834C8.00359 15.7621 7.98518 15.6061 8.009 15.4844C8.08586 15.1026 8.54596 14.6224 9.2399 14.1986C9.32217 14.1477 9.67076 13.9585 9.68592 13.9508L9.88945 13.8401C10.0865 13.4949 10.3041 13.0888 10.5444 12.6086L10.5747 12.5499L10.5813 12.5368C10.807 12.0841 11.0628 11.5713 11.2665 11.0628L11.3401 10.8802C11.0532 9.75602 10.8941 8.88852 11.0478 8.30871C11.0976 8.12393 11.2903 8 11.5274 8L11.6551 8.00332C11.8673 7.99336 12.0026 8.16598 12.0719 8.32863L12.0936 8.38728C12.1109 8.43928 12.1174 8.4603 12.1261 8.5278C12.1932 9.02573 11.9388 10.4996 11.9388 10.4996C11.9269 10.5549 11.9139 10.608 11.8987 10.67C12.1326 11.3272 12.5093 11.9237 12.9596 12.3541C13.1274 12.5134 13.3407 12.6473 13.5475 12.769C14.0098 12.7037 14.4493 12.6705 14.8141 12.6739ZM9.45858 14.4232C8.93028 14.8658 8.57302 15.3638 8.48317 15.616C8.72675 15.5032 9.09699 15.1447 9.64803 14.2451C9.57333 14.3181 9.49105 14.3956 9.45858 14.4232ZM11.8673 9.05228C11.8597 8.66833 11.7688 8.25892 11.6097 8.25892C11.538 8.25892 11.5435 8.82598 11.5436 8.84065L11.5436 8.84094C11.5436 9.14523 11.588 9.60996 11.6779 9.90539C11.7872 9.70622 11.8749 9.43624 11.8673 9.05228ZM11.0197 12.8586C10.9017 13.0855 10.788 13.299 10.6765 13.5015C11.2849 13.2625 11.9756 13.0667 12.7745 12.9051C12.7193 12.8631 12.6674 12.8199 12.6186 12.7779C12.2257 12.4382 11.8911 12.0133 11.6227 11.5142C11.4873 11.8705 11.3065 12.3032 11.0197 12.8586ZM15.4388 13.5048C15.5275 13.5048 15.6672 13.4871 15.7159 13.4562C15.7646 13.4241 15.7603 13.2736 15.4767 13.1994C15.1982 13.1264 15.1101 13.1264 14.83 13.1264H14.8174C14.6582 13.1264 14.4818 13.1342 14.2891 13.1485C14.7914 13.3698 15.1497 13.5048 15.4388 13.5048Z",
      fill: "#1A91F0"
    }
  )
] }), l2 = () => /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 1a2 2 0 0 0-2 2v18c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V7h-4a2 2 0 0 1-2-2V1H6Z",
      fill: "#6390F7"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M10.52 14.82 9.66 12H8l1.75 5h1.3l.95-2.78.94 2.78h1.3L16 12h-1.66l-.86 2.82-.94-2.82h-1.08l-.94 2.82Z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e("path", { d: "m14 1 3 3 3 3h-4a2 2 0 0 1-2-2V1Z", fill: "#A0BBF8" })
] }), o2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 1a2 2 0 0 0-2 2v18c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V7h-4a2 2 0 0 1-2-2V1H6Z",
          fill: "#CFD6E6"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M10.5 14.8 9.7 12H8l1.8 5H11l.9-2.8 1 2.8h1.2l1.8-5h-1.7l-.8 2.8-1-2.8h-1l-1 2.8Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ e("path", { d: "m14 1 3 3 3 3h-4a2 2 0 0 1-2-2V1Z", fill: "#DDE3F0" })
    ]
  }
), d2 = () => /* @__PURE__ */ t("g", { children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M6 1a2 2 0 0 0-2 2v18c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V7h-4a2 2 0 0 1-2-2V1H6Z",
      fill: "#1DA1F2"
    }
  ),
  /* @__PURE__ */ e("path", { d: "M15 11H9v2h2v4h2v-4h2v-2Z", fill: "#fff" }),
  /* @__PURE__ */ e("path", { d: "m14 1 3 3 3 3h-4a2 2 0 0 1-2-2V1Z", fill: "#85D0FF" })
] }), n2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 4a1 1 0 0 1 1 1c0 3.4 3 6 6 6a1 1 0 1 1 0 2c-1.42 0-2.93.72-4.1 1.9a6.03 6.03 0 0 0-1.9 4.1 1 1 0 1 1-2 0c0-3-2.6-6-6-6a1 1 0 1 1 0-2c3.45 0 6-2.55 6-6a1 1 0 0 1 1-1Zm.05 4.9a7.66 7.66 0 0 1-3.16 3.15 8.38 8.38 0 0 1 3.16 3.28 9.14 9.14 0 0 1 3.28-3.28 8.38 8.38 0 0 1-3.28-3.16ZM4 4a1 1 0 0 1 1 1c0 .55.5 1 1 1a1 1 0 0 1 0 2c-.17 0-.43.1-.67.33-.23.24-.33.5-.33.67a1 1 0 1 1-2 0c0-.5-.45-1-1-1a1 1 0 0 1 0-2c.6 0 1-.4 1-1a1 1 0 0 1 1-1ZM6.98 15a1 1 0 0 1 1 .83c.12.63.24.83.32.91.07.07.24.19.83.27a1 1 0 0 1 0 1.98c-.65.1-.84.2-.9.27-.05.05-.18.2-.23.83a1 1 0 0 1-1.99.06c-.1-.66-.2-.85-.27-.92-.03-.04-.17-.18-.83-.23a1 1 0 0 1 .02-2c.6-.04.74-.15.79-.2.06-.05.2-.24.29-.94a1 1 0 0 1 .97-.86Z"
  }
) }), s2 = () => /* @__PURE__ */ t("g", { stroke: "null", id: "svg_4", children: [
  /* @__PURE__ */ e(
    "path",
    {
      stroke: "currentColor",
      id: "svg_1",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      fill: "currentColor",
      d: "m20.76114,11.56774c-2.992,0 -5.984,-2.59361 -5.984,-6.05169c0,3.45811 -2.56446,6.05169 -5.98394,6.05169c3.41943,0 5.98394,3.02584 5.98394,6.05169c0,-3.02584 2.992,-6.05169 5.984,-6.05169z"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      stroke: "currentColor",
      id: "svg_2",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "m6.65829,7.2451c-0.85486,0 -1.70971,-0.74103 -1.70971,-1.72905c0,0.98802 -0.73271,1.72905 -1.70971,1.72905c0.97697,0 1.70971,0.86453 1.70971,1.72905c0,-0.86453 0.85486,-1.72905 1.70971,-1.72905z"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      stroke: "currentColor",
      id: "svg_3",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "m9.22397,16.7549c-1.13816,-0.1559 -1.50516,-0.54725 -1.70971,-1.72908c-0.17512,1.28976 -0.58327,1.64436 -1.70971,1.72908c1.28149,0.11513 1.54021,0.59739 1.70971,1.72905c0.11109,-1.22835 0.5333,-1.56364 1.70971,-1.72905z"
    }
  )
] }), r2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.523 4.268a.9.9 0 0 0-1.046 0l-7 5a.9.9 0 1 0 1.046 1.464L12 6.106l6.477 4.626a.9.9 0 1 0 1.046-1.464l-7-5ZM7.9 12a.9.9 0 1 0-1.8 0v6a.9.9 0 0 0 .9.9h10a.9.9 0 0 0 .9-.9v-6a.9.9 0 1 0-1.8 0v5.1H7.9V12Z",
    clipRule: "evenodd"
  }
) }), a2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v6h3v-9.2l-6-6-6 6V20h3v-6Zm2 7c0 .5-.4 1-1 1H5a1 1 0 0 1-1-1V10.4c0-.3.1-.5.3-.7l7-7a1 1 0 0 1 1.4 0l7 7c.2.2.3.4.3.7V21c0 .5-.4 1-1 1h-5a1 1 0 0 1-1-1v-6h-2v6Z"
  }
) }), L2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-4Zm0 2h4v7h-4V5Zm9 5a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4Zm0 2h4v7h-4v-7Zm-2-7c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5Zm6 0h-4v2h4V5Zm-13 10a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4Zm0 2h4v2h-4v-2Z"
  }
) }), c2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17h-7v2h4v2H7v-2h4v-2H4a1 1 0 0 1-1-1V4c0-.6.4-1 1-1h16c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1ZM5 15V5h14v10h-2.1a5 5 0 0 0-3-3.6 3 3 0 1 0-3.8 0 5 5 0 0 0-3 3.6H5Zm4.2 0h5.6a3 3 0 0 0-5.6 0ZM13 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }
) }), v2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C10 4.44772 10.4477 4 11 4C11.5523 4 12 4.44772 12 5V7H14H17V10V12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14H17V16V19H14.874C14.4299 17.2748 12.8638 16 11 16C9.13616 16 7.57006 17.2748 7.12602 19H5V16.874C6.72523 16.4299 8 14.8638 8 13C8 11.1362 6.72523 9.57006 5 9.12602V7H8H10V5ZM19 16V20C19 20.5523 18.5523 21 18 21H14C13.4477 21 13 20.5523 13 20C13 18.8954 12.1046 18 11 18C9.89543 18 9 18.8954 9 20C9 20.5523 8.55228 21 8 21H4C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15C5.10457 15 6 14.1046 6 13C6 11.8954 5.10457 11 4 11C3.44772 11 3 10.5523 3 10V6C3 5.44772 3.44772 5 4 5H8C8 3.34315 9.34315 2 11 2C12.6569 2 14 3.34315 14 5H18C18.5523 5 19 5.44772 19 6V10C20.6569 10 22 11.3431 22 13C22 14.6569 20.6569 16 19 16Z"
  }
) }), V2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "20",
    height: "18",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.6 4H15V2C15 0.9 14.1 0 13 0L7.00002 0C5.90002 0 5.00002 0.9 5.00002 2L5.00002 4L2.40002 4C1.30002 4 0.400024 4.9 0.400024 6L0.400024 16C0.400024 17.1 1.30002 18 2.40002 18L17.6 18C18.7 18 19.6 17.1 19.6 16L19.6 6C19.6 4.9 18.7 4 17.6 4ZM12 8H8.00002C7.45002 8 7.00002 8.45 7.00002 9V9.99C4.68002 9.96 2.77002 8.24 2.45002 6L6.00002 6L14 6L17.55 6C17.23 8.24 15.32 9.96 13 9.99V9C13 8.45 12.55 8 12 8ZM11 10V12H9.00002V10H11ZM7.00002 2L13 2V4L7.00002 4L7.00002 2ZM2.40002 16L2.40002 10.07C3.59002 11.24 5.20002 11.98 7.00002 12V13C7.00002 13.55 7.45002 14 8.00002 14H12C12.55 14 13 13.55 13 13V12C14.79 11.98 16.41 11.25 17.6 10.08L17.6 16L2.40002 16Z",
        fill: "currentColor"
      }
    )
  }
), w2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6004 6H17.0004V4C17.0004 2.9 16.1004 2 15.0004 2L9.00039 2C7.90039 2 7.00039 2.9 7.00039 4L7.00039 6L4.40039 6C3.30039 6 2.40039 6.9 2.40039 8L2.40039 18C2.40039 19.1 3.30039 20 4.40039 20L19.6004 20C20.7004 20 21.6004 19.1 21.6004 18L21.6004 8C21.6004 6.9 20.7004 6 19.6004 6ZM14.0004 10H10.0004C9.45039 10 9.00039 10.45 9.00039 11V11.99C6.68039 11.96 4.77039 10.24 4.45039 8H8.00039L16.0004 8L19.5504 8C19.2304 10.24 17.3204 11.96 15.0004 11.99V11C15.0004 10.45 14.5504 10 14.0004 10ZM13.0004 12V14H11.0004V12H13.0004ZM9.00039 4L15.0004 4V6L9.00039 6V4ZM4.40039 18L4.40039 12.07C5.59039 13.24 7.20039 13.98 9.00039 14V15C9.00039 15.55 9.45039 16 10.0004 16H14.0004C14.5504 16 15.0004 15.55 15.0004 15V14C16.7904 13.98 18.4104 13.25 19.6004 12.08L19.6004 18L4.40039 18Z"
  }
) }), g2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17H13V19H17V21H7V19H11V17H4C3.44772 17 3 16.5523 3 16V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V16C21 16.5523 20.5523 17 20 17ZM5 15V5H19V15H16.8999C16.5623 13.3369 15.3993 11.9736 13.857 11.3562C14.5531 10.8069 14.9999 9.95561 14.9999 9C14.9999 7.34315 13.6568 6 11.9999 6C10.3431 6 8.99991 7.34315 8.99991 9C8.99991 9.95561 9.44671 10.8069 10.1428 11.3562C8.60057 11.9736 7.43752 13.3369 7.09993 15H5ZM9.17062 15H14.8292C14.4174 13.8348 13.3061 13 11.9999 13C10.6937 13 9.58245 13.8348 9.17062 15ZM12.9999 9C12.9999 9.55228 12.5522 10 11.9999 10C11.4476 10 10.9999 9.55228 10.9999 9C10.9999 8.44772 11.4476 8 11.9999 8C12.5522 8 12.9999 8.44772 12.9999 9Z"
  }
) }), p2 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  /* @__PURE__ */ t("g", { clipPath: "url(#clip0_1703_48172)", children: [
    /* @__PURE__ */ e("mask", { id: "path-1-inside-1_1703_48172", fill: "currentColor", children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.53553 13.143L4.53516 13.1426C2.58291 11.1899 2.58304 8.02438 4.53553 6.07189C6.48803 4.11939 9.65357 4.11927 11.6062 6.07151C13.5589 4.11927 16.7244 4.11939 18.6769 6.07189C20.6294 8.02438 20.6295 11.1899 18.6773 13.1426C18.6772 13.1427 18.677 13.1428 18.6769 13.143L11.6062 20.2136L4.53553 13.143Z"
      }
    ) }),
    /* @__PURE__ */ e(
      "path",
      {
        d: "M4.53516 13.1426L3.12079 14.5566L3.12094 14.5568L4.53516 13.1426ZM11.6062 6.07151L10.1922 7.48587L11.6062 8.89964L13.0203 7.48587L11.6062 6.07151ZM18.6773 13.1426L20.0915 14.5568L20.0917 14.5566L18.6773 13.1426ZM18.6769 13.143L20.0911 14.5572L18.6769 13.143ZM11.6062 20.2136L10.192 21.6279L11.6062 23.0421L13.0204 21.6279L11.6062 20.2136ZM3.12094 14.5568L3.12132 14.5572L5.94975 11.7287L5.94937 11.7284L3.12094 14.5568ZM3.12132 4.65767C0.387826 7.39117 0.38765 11.8229 3.12079 14.5566L5.94952 11.7285C4.77817 10.5569 4.77825 8.6576 5.94975 7.4861L3.12132 4.65767ZM13.0203 4.65715C10.2866 1.924 5.85482 1.92418 3.12132 4.65767L5.94975 7.4861C7.12124 6.31461 9.02057 6.31453 10.1922 7.48587L13.0203 4.65715ZM13.0203 7.48587C14.1919 6.31453 16.0912 6.3146 17.2627 7.4861L20.0911 4.65767C17.3576 1.92418 12.9259 1.924 10.1922 4.65715L13.0203 7.48587ZM17.2627 7.4861C18.4342 8.6576 18.4343 10.5569 17.2629 11.7285L20.0917 14.5566C22.8248 11.8229 22.8246 7.39117 20.0911 4.65767L17.2627 7.4861ZM17.2631 11.7284C17.263 11.7284 17.263 11.7285 17.2629 11.7286C17.2628 11.7286 17.2628 11.7287 17.2627 11.7287L20.0911 14.5572C20.0912 14.5571 20.0913 14.557 20.0913 14.557C20.0914 14.5569 20.0914 14.5569 20.0915 14.5568L17.2631 11.7284ZM13.0204 21.6279L20.0911 14.5572L17.2627 11.7287L10.192 18.7994L13.0204 21.6279ZM3.12132 14.5572L10.192 21.6279L13.0204 18.7994L5.94975 11.7287L3.12132 14.5572Z",
        mask: "url(#path-1-inside-1_1703_48172)"
      }
    )
  ] }),
  /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_1703_48172", children: /* @__PURE__ */ e("rect", { width: "24", height: "24", fill: "currentColor" }) }) })
] }), M2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e("g", { children: /* @__PURE__ */ e(
  "path",
  {
    fill: "currentColor",
    d: "m6.11916,12.81625c-1.62386,-1.6239 -1.62386,-4.2567 0,-5.8806c1.62385,-1.62381 4.25665,-1.62381 5.88055,0c1.6238,-1.62381 4.2573,-1.62381 5.8811,0c1.6239,1.6239 1.6239,4.2567 0,5.8806c-0.0148,0.0148 -0.0297,0.0294 -0.0447,0.044l-5.129,5.129c-0.3905,0.3906 -1.0237,0.3906 -1.4142,0l-5.12907,-5.129c-0.01498,-0.0146 -0.02987,-0.0292 -0.04468,-0.044z"
  }
) }) }), f2 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M2 12C2.82843 12 3.5 12.6716 3.5 13.5C3.5 14.3284 2.82843 15 2 15C1.17157 15 0.5 14.3284 0.5 13.5C0.5 12.6716 1.17157 12 2 12Z",
      fill: "#0F141E"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M2 6C2.82843 6 3.5 6.67157 3.5 7.5C3.5 8.32843 2.82843 9 2 9C1.17157 9 0.5 8.32843 0.5 7.5C0.5 6.67157 1.17157 6 2 6Z",
      fill: "#0F141E"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      d: "M2 0C2.82843 0 3.5 0.671573 3.5 1.5C3.5 2.32843 2.82843 3 2 3C1.17157 3 0.5 2.32843 0.5 1.5C0.5 0.671573 1.17157 0 2 0Z",
      fill: "#0F141E"
    }
  )
] }), Z2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.2 11C15.2 13.3196 13.3196 15.2 11 15.2C8.6804 15.2 6.8 13.3196 6.8 11C6.8 8.6804 8.6804 6.8 11 6.8C13.3196 6.8 15.2 8.6804 15.2 11ZM17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 7.68629 7.68629 5 11 5C14.3137 5 17 7.68629 17 11ZM19.4364 18.1636L17.6364 16.3636C17.2849 16.0121 16.7151 16.0121 16.3636 16.3636C16.0121 16.7151 16.0121 17.2849 16.3636 17.6364L18.1636 19.4364C18.5151 19.7879 19.0849 19.7879 19.4364 19.4364C19.7879 19.0849 19.7879 18.5151 19.4364 18.1636Z",
        fill: "#828BA2"
      }
    )
  }
), u2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98411 4.87682C7.85509 4.37667 7.14482 4.37667 7.01581 4.87682L6.75338 5.89412C6.70793 6.07033 6.57033 6.20793 6.39412 6.25338L5.37682 6.51581C4.87667 6.64482 4.87667 7.35509 5.37682 7.48411L6.39412 7.74653C6.57033 7.79199 6.70793 7.92959 6.75338 8.10579L7.01581 9.1231C7.14482 9.62324 7.85509 9.62324 7.98411 9.1231L8.24653 8.10579C8.29199 7.92958 8.42959 7.79199 8.60579 7.74653L9.6231 7.48411C10.1232 7.35509 10.1232 6.64482 9.6231 6.51581L8.60579 6.25338C8.42958 6.20793 8.29199 6.07033 8.24653 5.89412L7.98411 4.87682ZM15.1619 6.70197C14.8523 5.50162 13.1476 5.50162 12.838 6.70197L11.8873 10.3873L8.20197 11.338C7.00162 11.6476 7.00162 13.3523 8.20197 13.6619L11.8873 14.6126L12.838 18.2979C13.1476 19.4983 14.8523 19.4983 15.1619 18.2979L16.1126 14.6126L19.7979 13.6619C20.9983 13.3523 20.9983 11.6476 19.7979 11.338L16.1126 10.3873L15.1619 6.70197ZM13.2135 10.8513L14 7.80241L14.7864 10.8513C14.8955 11.2742 15.2258 11.6044 15.6487 11.7135L18.6975 12.5L15.6487 13.2864C15.2258 13.3955 14.8955 13.7258 14.7864 14.1487L14 17.1975L13.2135 14.1487C13.1044 13.7258 12.7742 13.3955 12.3513 13.2864L9.30241 12.5L12.3513 11.7135C12.7742 11.6044 13.1044 11.2742 13.2135 10.8513Z",
    fill: "currentColor"
  }
) }), x2 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50501 9.50483C6.23165 9.7782 6.23165 10.2214 6.50501 10.4948L11.505 15.4948C11.7784 15.7681 12.2216 15.7681 12.495 15.4948L17.495 10.4948C17.7683 10.2214 17.7683 9.7782 17.495 9.50483C17.2216 9.23146 16.7784 9.23146 16.505 9.50483L12 14.0099L7.49496 9.50483C7.2216 9.23146 6.77838 9.23146 6.50501 9.50483Z"
  }
) }), H2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ t("g", { children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M14.7279 0.800049C14.9127 0.833368 15.0975 0.854926 15.2784 0.900005C15.6855 0.999653 16.0516 1.22465 16.3259 1.54371C16.6002 1.86276 16.769 2.26001 16.8088 2.6802C16.8486 3.10038 16.7574 3.52263 16.548 3.88819C16.3386 4.25376 16.0213 4.54447 15.6402 4.7199C15.0898 4.97469 14.5295 5.11189 13.9304 4.89434C13.4773 4.75334 13.0894 4.45334 12.8371 4.04878C12.5848 3.64423 12.4848 3.16193 12.5552 2.68942C12.617 2.21803 12.8317 1.78043 13.1659 1.44475C13.5001 1.10906 13.9351 0.894115 14.4031 0.833367C14.4569 0.825283 14.5101 0.81416 14.5626 0.800049H14.7279Z",
            fill: "#1A91F0"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M15.1165 29.1856C7.03429 29.1856 4.04652 30.5576 4.02901 25.3794C4.01928 23.0452 3.52521 14.8252 7.03429 17.622C8.26364 18.602 7.20158 24.2642 7.91351 26.0497C11.584 26.3261 22.2747 26.1026 23.5507 25.4618C23.8016 23.0589 22.8038 18.406 24.603 17.0341C27.8145 14.5724 27.1318 23.1726 27.1609 25.6009C27.2387 30.7536 24.78 29.1856 15.1165 29.1856Z",
            fill: "#1A91F0"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M13.9948 10.6449C13.742 10.9134 12.2734 12.8831 11.8902 13.1928C11.7554 13.3097 11.5979 13.3969 11.4278 13.4489C11.2576 13.5009 11.0785 13.5164 10.902 13.4946C10.1843 13.3927 9.77967 12.7106 9.99558 11.9913C10.2134 10.8154 11.9407 9.44342 12.7344 8.26747C12.8705 8.07148 13.8237 6.53293 13.9948 6.36242C14.6367 5.71956 14.9674 5.70388 15.7299 6.20367C16.1034 6.45258 17.1188 8.13223 17.4631 8.42622C18.6029 9.40619 19.1573 9.71781 19.9918 10.9741C20.3069 11.4523 20.41 12.3461 19.9607 12.7067C19.7836 12.8805 19.5563 12.9931 19.3116 13.0283C19.0668 13.0635 18.8174 13.0195 18.599 12.9027C18.0894 12.6871 17.7801 12.252 17.3075 11.7757C16.6772 11.1407 16.2279 10.6664 16.047 10.5037C16.0587 10.7174 16.4516 14.4687 16.5197 16.0621C16.5877 17.6947 16.7511 18.8785 16.8348 20.5092C16.9068 21.9458 16.1423 22.5945 15.5743 22.573C15.3201 22.5634 15.0705 22.5017 14.8407 22.3917C14.611 22.2816 14.4059 22.1255 14.2381 21.9329C14.0702 21.7403 13.9431 21.5152 13.8645 21.2714C13.7859 21.0277 13.7574 20.7703 13.7809 20.5151C13.8392 19.2391 13.9968 18.6041 13.9968 15.2683C14.0046 14.2746 13.9929 10.7154 13.9948 10.6449Z",
            fill: "#1A91F0"
          }
        )
      ] }),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_1009_10231", children: /* @__PURE__ */ e("rect", { width: "23.2", height: "30.6043", fill: "white", transform: "translate(4 0.800049)" }) }) })
    ]
  }
), k2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 3.30005C5.83726 3.30005 5.3 3.83731 5.3 4.50005V7.00005H4C3.44772 7.00005 3 7.44776 3 8.00005V16C3 16.5523 3.44772 17 4 17H5.3V19.5C5.3 20.1628 5.83726 20.7001 6.5 20.7001H17.5C18.1627 20.7001 18.7 20.1628 18.7 19.5V7.70716C18.7 7.3889 18.5736 7.08367 18.3485 6.85863L15.1414 3.65152C14.9164 3.42648 14.6112 3.30005 14.2929 3.30005H6.5ZM6.7 17V19.3H17.3V7.79L14.2101 4.70005H6.7V7.00005H12C12.5523 7.00005 13 7.44776 13 8.00005V16C13 16.5523 12.5523 17 12 17H6.7ZM5.25 10.5C5.25 9.80969 5.80964 9.25005 6.5 9.25005H9.5C10.1904 9.25005 10.75 9.80969 10.75 10.5V12C10.75 12.6904 10.1904 13.25 9.5 13.25H6.75V14.5C6.75 14.9143 6.41421 15.25 6 15.25C5.58579 15.25 5.25 14.9143 5.25 14.5V12.5V10.5ZM6.75 11.75H9.25V10.75H6.75V11.75Z",
        fill: "#DA0C22"
      }
    )
  }
), B2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M17 14L12 9L7 14",
        stroke: "#0F141E",
        strokeWidth: "1.4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), m2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.2 11C15.2 13.3196 13.3196 15.2 11 15.2C8.6804 15.2 6.8 13.3196 6.8 11C6.8 8.6804 8.6804 6.8 11 6.8C13.3196 6.8 15.2 8.6804 15.2 11ZM17 11C17 14.3137 14.3137 17 11 17C7.68629 17 5 14.3137 5 11C5 7.68629 7.68629 5 11 5C14.3137 5 17 7.68629 17 11ZM19.4364 18.1636L17.6364 16.3636C17.2849 16.0121 16.7151 16.0121 16.3636 16.3636C16.0121 16.7151 16.0121 17.2849 16.3636 17.6364L18.1636 19.4364C18.5151 19.7879 19.0849 19.7879 19.4364 19.4364C19.7879 19.0849 19.7879 18.5151 19.4364 18.1636Z",
        fill: "#1E2532"
      }
    )
  }
), R2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M7 10L12 15L17 10",
        stroke: "#495163",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), F2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 3.30005C5.83726 3.30005 5.3 3.83731 5.3 4.50005V7.50005H4C3.44772 7.50005 3 7.94776 3 8.50005V16.5C3 17.0523 3.44772 17.5 4 17.5H5.3V19.5C5.3 20.1628 5.83726 20.7001 6.5 20.7001H17.5C18.1627 20.7001 18.7 20.1628 18.7 19.5V7.70716C18.7 7.3889 18.5736 7.08367 18.3485 6.85863L15.1414 3.65152C14.9164 3.42648 14.6112 3.30005 14.2929 3.30005H6.5ZM6.7 17.5V19.3H17.3V7.79L14.2101 4.70005H6.7V7.50005H12C12.5523 7.50005 13 7.94776 13 8.50005V16.5C13 17.0523 12.5523 17.5 12 17.5H6.7ZM5.359 9.86528C5.70943 9.78741 6.05665 10.0084 6.13452 10.3588L6.71972 12.9922L7.31098 11.7252C7.42873 11.4728 7.68785 11.3316 7.95 11.3518C8.21215 11.3316 8.47127 11.4728 8.58902 11.7252L9.24803 13.1373L9.86548 10.3588C9.94335 10.0084 10.2906 9.78741 10.641 9.86528C10.9914 9.94316 11.2124 10.2904 11.1345 10.6408L10.1345 15.1408C10.0636 15.4601 9.76903 15.6719 9.45218 15.6481C9.18929 15.6693 8.92906 15.5279 8.81098 15.2749L7.95 13.43L7.08902 15.2749C6.93721 15.6002 6.55043 15.7409 6.22512 15.5891C6.0984 15.5299 5.9997 15.4351 5.9354 15.3222C5.9195 15.2943 5.90554 15.2651 5.89375 15.2345C5.88068 15.2007 5.87044 15.1658 5.86314 15.1303L4.86548 10.6408C4.7876 10.2904 5.00856 9.94316 5.359 9.86528Z",
        fill: "#1170CD"
      }
    )
  }
), _2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 3.30005C5.83726 3.30005 5.3 3.83731 5.3 4.50005V7.00005H4C3.44772 7.00005 3 7.44776 3 8.00005V16C3 16.5523 3.44772 17 4 17H5.3V19.5C5.3 20.1628 5.83726 20.7001 6.5 20.7001H17.5C18.1627 20.7001 18.7 20.1628 18.7 19.5V7.70716C18.7 7.3889 18.5736 7.08367 18.3485 6.85863L15.1414 3.65152C14.9164 3.42648 14.6112 3.30005 14.2929 3.30005H6.5ZM6.7 17V19.3H17.3V7.79L14.2101 4.70005H6.7V7.00005H12C12.5523 7.00005 13 7.44776 13 8.00005V16C13 16.5523 12.5523 17 12 17H6.7ZM5.25 10C5.25 9.58584 5.58579 9.25005 6 9.25005H8H10C10.4142 9.25005 10.75 9.58584 10.75 10C10.75 10.4143 10.4142 10.75 10 10.75H8.75V14.5C8.75 14.9143 8.41421 15.25 8 15.25C7.58579 15.25 7.25 14.9143 7.25 14.5V10.75H6C5.58579 10.75 5.25 10.4143 5.25 10Z",
        fill: "#656E83"
      }
    )
  }
), A2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0001 5.89998C10.8403 5.89998 9.9001 6.84018 9.9001 7.99998C9.9001 9.15977 10.8403 10.1 12.0001 10.1C13.1599 10.1 14.1001 9.15977 14.1001 7.99998C14.1001 6.84018 13.1599 5.89998 12.0001 5.89998ZM15.9001 7.99998C15.9001 9.84412 14.6201 11.3893 12.9001 11.7956V15C12.9001 15.497 12.4972 15.9 12.0001 15.9C11.503 15.9 11.1001 15.497 11.1001 15L11.1001 11.7956C9.38008 11.3893 8.1001 9.84412 8.1001 7.99998C8.1001 5.84607 9.84619 4.09998 12.0001 4.09998C14.154 4.09998 15.9001 5.84607 15.9001 7.99998ZM16.1693 13.1303C15.689 13.0023 15.1959 13.2879 15.0679 13.7682C14.94 14.2485 15.2256 14.7416 15.7059 14.8696C16.5688 15.0996 17.2205 15.3932 17.6347 15.6928C18.0649 16.004 18.1001 16.2111 18.1001 16.2631C18.1001 16.3059 18.0815 16.4435 17.8391 16.6675C17.5957 16.8925 17.1941 17.1365 16.6221 17.3602C15.4838 17.8052 13.85 18.1 12.0001 18.1C10.1502 18.1 8.51636 17.8052 7.37807 17.3602C6.80614 17.1365 6.40451 16.8925 6.16111 16.6675C5.91871 16.4435 5.9001 16.3059 5.9001 16.2631C5.9001 16.2154 5.92693 16.0386 6.27324 15.7628C6.61219 15.4928 7.15514 15.217 7.89427 14.9853C8.36857 14.8367 8.63256 14.3317 8.4839 13.8574C8.33525 13.3831 7.83024 13.1191 7.35593 13.2677C6.49474 13.5376 5.72519 13.898 5.15172 14.3549C4.58561 14.8058 4.1001 15.4466 4.1001 16.2631C4.1001 16.9761 4.47324 17.5585 4.93928 17.9893C5.40431 18.4192 6.02781 18.7649 6.72263 19.0366C8.11784 19.5821 9.98403 19.9 12.0001 19.9C14.0162 19.9 15.8824 19.5821 17.2776 19.0366C17.9724 18.7649 18.5959 18.4192 19.0609 17.9893C19.527 17.5585 19.9001 16.9761 19.9001 16.2631C19.9001 15.3744 19.3283 14.6963 18.6895 14.2343C18.0347 13.7606 17.1551 13.393 16.1693 13.1303Z",
        fill: "currentColor"
      }
    )
  }
), z2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e("g", { id: "Group 337943", children: /* @__PURE__ */ t("g", { id: "Group 337942", children: [
      /* @__PURE__ */ e(
        "path",
        {
          id: "Union",
          d: "M7.85714 15.9999L8.6164 15.3491L8.31708 14.9999H7.85714V15.9999ZM7.85714 7.99992V8.99992H8.31708L8.6164 8.65071L7.85714 7.99992ZM11.2407 4.05238L12 4.70317V4.70317L11.2407 4.05238ZM11.2407 19.9475L12 19.2967H12L11.2407 19.9475ZM7.85714 14.9999H5V16.9999H7.85714V14.9999ZM5 14.9999C4.44771 14.9999 4 14.5522 4 13.9999H2C2 15.6568 3.34315 16.9999 5 16.9999V14.9999ZM4 13.9999V9.99992H2V13.9999H4ZM4 9.99992C4 9.44763 4.44772 8.99992 5 8.99992V6.99992C3.34315 6.99992 2 8.34306 2 9.99992H4ZM5 8.99992H7.85714V6.99992H5V8.99992ZM8.6164 8.65071L12 4.70317L10.4815 3.40159L7.09789 7.34913L8.6164 8.65071ZM12 4.70317H14C14 2.84636 11.6899 1.99179 10.4815 3.40159L12 4.70317ZM12 4.70317V19.2967H14V4.70317H12ZM12 19.2967L12 19.2967L10.4815 20.5982C11.6899 22.008 14 21.1535 14 19.2967H12ZM12 19.2967L8.6164 15.3491L7.09789 16.6507L10.4815 20.5982L12 19.2967Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          id: "Ellipse 147",
          d: "M16.2939 8.5C16.7485 9.57589 16.9999 10.7586 16.9999 12C16.9999 13.2414 16.7485 14.4241 16.2939 15.5",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          id: "Ellipse 148",
          d: "M20 6C20.6439 7.84438 21 9.87187 21 12C21 14.1281 20.6439 16.1556 20 18",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      )
    ] }) })
  }
), b2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e("g", { id: "Group 337944", children: /* @__PURE__ */ e("g", { id: "Group 337939", children: /* @__PURE__ */ t("g", { id: "Group 337930", children: [
      /* @__PURE__ */ e(
        "path",
        {
          id: "Vector 87",
          d: "M8 22H16",
          stroke: "#1A91F0",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          id: "Vector 88",
          d: "M12 19V22",
          stroke: "#1A91F0",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ e(
        "rect",
        {
          id: "Rectangle 5589",
          x: "8",
          y: "2",
          width: "8",
          height: "13",
          rx: "4",
          stroke: "#1A91F0",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          id: "Ellipse 143",
          d: "M19.6017 13.5C18.5519 16.6939 15.5453 19 12.0001 19C8.45484 19 5.44823 16.6939 4.39844 13.5",
          stroke: "#1A91F0",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      )
    ] }) }) })
  }
), W2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("path", { d: "M8 22H16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ e("path", { d: "M12 19V22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }),
      /* @__PURE__ */ e("rect", { x: "8", y: "2", width: "8", height: "13", rx: "4", stroke: "currentColor", strokeWidth: "2" }),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M19.6017 13.5C18.5519 16.6939 15.5453 19 12.0001 19C8.45484 19 5.44823 16.6939 4.39844 13.5",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "1",
          y: "3.82812",
          width: "2",
          height: "26.9731",
          rx: "1",
          transform: "rotate(-45 1 3.82812)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "2.41406",
          y: "2.41406",
          width: "2",
          height: "26.9731",
          rx: "1",
          transform: "rotate(-45 2.41406 2.41406)",
          fill: "currentColor"
        }
      )
    ]
  }
), y2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("rect", { width: "24", height: "24", fill: "white" }),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.92822 8.38119L11.9282 4.91708L17.9282 8.38119V15.3094L11.9282 18.7735L5.92822 15.3094V8.38119ZM11.3509 2.94102C11.7081 2.73475 12.1483 2.73475 12.5056 2.94102L19.3509 6.89315C19.7081 7.09942 19.9282 7.48062 19.9282 7.89315V15.7974C19.9282 16.21 19.7081 16.5912 19.3509 16.7974L12.5056 20.7496C12.1483 20.9558 11.7081 20.9558 11.3509 20.7496L4.50557 16.7974C4.14831 16.5912 3.92822 16.21 3.92822 15.7974V7.89315C3.92822 7.48062 4.14831 7.09942 4.50557 6.89315L11.3509 2.94102ZM13.3923 11.8453C13.3923 12.6539 12.7368 13.3094 11.9282 13.3094C11.1196 13.3094 10.4641 12.6539 10.4641 11.8453C10.4641 11.0367 11.1196 10.3812 11.9282 10.3812C12.7368 10.3812 13.3923 11.0367 13.3923 11.8453ZM15.3923 11.8453C15.3923 13.7585 13.8414 15.3094 11.9282 15.3094C10.0151 15.3094 8.46412 13.7585 8.46412 11.8453C8.46412 9.93212 10.0151 8.38119 11.9282 8.38119C13.8414 8.38119 15.3923 9.93212 15.3923 11.8453Z"
        }
      )
    ]
  }
), E2 = (i) => /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M10.8 3.185a8.494 8.494 0 0 0-2.7.833c-.985.482-1.613.929-2.383 1.699S4.5 7.115 4.018 8.1c-.631 1.291-.898 2.451-.898 3.9 0 1.449.267 2.609.898 3.9.482.985.929 1.613 1.699 2.383.772.771 1.402 1.22 2.383 1.697 1.308.637 2.449.9 3.9.9 1.403 0 2.6-.269 3.833-.86a8.504 8.504 0 0 0 2.451-1.736 8.445 8.445 0 0 0 1.755-2.494c.576-1.209.841-2.403.841-3.79 0-1.451-.263-2.592-.9-3.9-.477-.981-.926-1.611-1.697-2.383-.77-.77-1.398-1.217-2.383-1.699a8.392 8.392 0 0 0-2.752-.837c-.586-.076-1.771-.074-2.348.004m2.1 1.78a7.328 7.328 0 0 1 2.82.992 7.174 7.174 0 0 1 3.319 5.119c.06.431.06 1.417 0 1.848-.373 2.661-2.16 4.869-4.659 5.757a6.794 6.794 0 0 1-2.38.405c-.66 0-1.074-.048-1.66-.193-1.308-.323-2.372-.915-3.314-1.844a7.115 7.115 0 0 1-2.065-4.125c-.06-.431-.06-1.417 0-1.848.372-2.66 2.163-4.872 4.659-5.757 1.068-.379 2.112-.491 3.28-.354m-.505 1.93c-.842.301-1.164 1.328-.619 1.973.059.07.206.176.326.235.197.096.252.105.549.089.378-.021.575-.104.852-.359.616-.567.51-1.567-.201-1.898-.232-.108-.662-.127-.907-.04m-.362 3.358c-.762.224-1.398.418-1.412.432-.014.014.021.093.077.176.295.435.295.877-.001 2.407-.2 1.037-.221 1.194-.208 1.572.016.48.115.76.353.99.26.253.44.31.979.31.462 0 .491-.005.747-.131.471-.232.819-.737 1.028-1.492.108-.389.108-.446-.002-.43-.069.01-.122.098-.252.413-.196.472-.354.724-.507.802-.138.072-.228.039-.261-.093-.016-.064.167-1.093.481-2.706.278-1.432.506-2.617.506-2.633-.002-.059-.159-.02-1.528.383",
    fillRule: "evenodd"
  }
) }), S2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 18H6L6 6L13 6V4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H13V18ZM14.7474 8.49999L16.8359 11H10L10 13H16.8359L14.7474 15.5L16.2526 16.817L19.7526 12.6585C20.0825 12.2815 20.0825 11.7185 19.7526 11.3415L16.2526 7.18298L14.7474 8.49999Z"
      }
    )
  }
), j2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M6 7H18.2M6 12H14.2M6 17H18.2",
        stroke: "#828BA2",
        strokeWidth: "1.8",
        strokeLinecap: "round"
      }
    )
  }
), D2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.84028 13.4241C4.74767 12.9586 4.70005 12.4818 4.70005 12C4.70005 11.5182 4.74767 11.0414 4.84028 10.5758C4.91571 10.1967 4.66948 9.82813 4.29031 9.75271C3.91114 9.67728 3.54261 9.92351 3.46719 10.3027C3.35679 10.8576 3.30005 11.4259 3.30005 12C3.30005 12.5741 3.35679 13.1423 3.46719 13.6973C3.54261 14.0765 3.91114 14.3227 4.29031 14.2473C4.66948 14.1718 4.91571 13.8033 4.84028 13.4241ZM5.9303 16.0557C5.71552 15.7342 5.28082 15.6478 4.95937 15.8625C4.63792 16.0773 4.55145 16.512 4.76623 16.8335C5.08058 17.3039 5.44229 17.7459 5.84822 18.1518C6.25415 18.5577 6.69611 18.9195 7.16658 19.2338C7.48803 19.4486 7.92273 19.3621 8.13751 19.0407C8.35228 18.7192 8.26581 18.2845 7.94436 18.0697C7.54965 17.806 7.17883 17.5025 6.83817 17.1619C6.49751 16.8212 6.19403 16.4504 5.9303 16.0557ZM4.76623 7.16652C4.55145 7.48797 4.63792 7.92267 4.95937 8.13745C5.28082 8.35222 5.71552 8.26575 5.9303 7.9443C6.19403 7.54959 6.49751 7.17877 6.83817 6.83811C7.17883 6.49745 7.54965 6.19396 7.94436 5.93024C8.26581 5.71546 8.35228 5.28076 8.13751 4.95931C7.92273 4.63786 7.48803 4.55139 7.16658 4.76617C6.69611 5.08052 6.25415 5.44223 5.84822 5.84816C5.44229 6.25409 5.08058 6.69605 4.76623 7.16652ZM10.5759 19.1598C10.1967 19.0843 9.82819 19.3306 9.75277 19.7097C9.67734 20.0889 9.92357 20.4574 10.3027 20.5329C10.8571 20.6431 11.4248 20.6999 11.9983 20.7C11.9989 20.7 11.9995 20.7 12 20.7C12.5741 20.7 13.1424 20.6432 13.6974 20.5329C14.0765 20.4574 14.3228 20.0889 14.2473 19.7097C14.1719 19.3306 13.8034 19.0843 13.4242 19.1598C12.9586 19.2524 12.4818 19.3 12 19.3C11.5183 19.3 11.0415 19.2524 10.5759 19.1598ZM10.3027 3.46713C9.92357 3.54255 9.67734 3.91108 9.75277 4.29025C9.8282 4.66942 10.1967 4.91565 10.5759 4.84022C11.0411 4.74769 11.5175 4.70007 11.9988 4.69999C11.9992 4.69999 11.9996 4.69999 12 4.69999C12.4818 4.69999 12.9586 4.74761 13.4242 4.84022C13.8034 4.91565 14.1719 4.66942 14.2473 4.29025C14.3228 3.91108 14.0765 3.54256 13.6974 3.46713C13.143 3.35684 12.5752 3.3001 12.0017 3.29999C12.0012 3.29999 12.0006 3.29999 12 3.29999C11.426 3.29999 10.8577 3.35673 10.3027 3.46713ZM19.1598 10.5758C19.2524 11.0414 19.3 11.5182 19.3 12C19.3 12.4818 19.2524 12.9586 19.1598 13.4242C19.0844 13.8033 19.3306 14.1718 19.7098 14.2473C20.089 14.3227 20.4575 14.0765 20.5329 13.6973C20.6433 13.1423 20.7 12.5741 20.7 12C20.7 11.4259 20.6433 10.8576 20.5329 10.3027C20.4575 9.92351 20.089 9.67728 19.7098 9.75271C19.3306 9.82814 19.0844 10.1967 19.1598 10.5758ZM18.0698 7.9443C18.2846 8.26575 18.7193 8.35223 19.0407 8.13745C19.3622 7.92267 19.4486 7.48797 19.2339 7.16652C18.9195 6.69605 18.5578 6.25409 18.1519 5.84816C17.7459 5.44223 17.304 5.08052 16.8335 4.76617C16.5121 4.55139 16.0774 4.63786 15.8626 4.95931C15.6478 5.28076 15.7343 5.71546 16.0557 5.93024C16.4504 6.19397 16.8213 6.49745 17.1619 6.83811C17.5026 7.17877 17.8061 7.54959 18.0698 7.9443ZM19.2339 16.8335C19.4486 16.512 19.3622 16.0773 19.0407 15.8625C18.7193 15.6478 18.2846 15.7342 18.0698 16.0557C17.8061 16.4504 17.5026 16.8212 17.1619 17.1619C16.8213 17.5025 16.4504 17.806 16.0557 18.0697C15.7343 18.2845 15.6478 18.7192 15.8626 19.0407C16.0774 19.3621 16.5121 19.4486 16.8335 19.2338C17.304 18.9195 17.7459 18.5578 18.1519 18.1518C18.5578 17.7459 18.9195 17.3039 19.2339 16.8335Z"
      }
    )
  }
), U2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.89998 12C4.89998 12.4686 4.94629 12.9323 5.03637 13.3851C5.13334 13.8726 4.81676 14.3464 4.32926 14.4434C3.84175 14.5404 3.36794 14.2238 3.27096 13.7363C3.15802 13.1686 3.09998 12.5872 3.09998 12C3.09998 11.4127 3.15802 10.8314 3.27096 10.2636C3.36794 9.77614 3.84175 9.45956 4.32926 9.55654C4.81676 9.65351 5.13334 10.1273 5.03637 10.6148C4.94629 11.0677 4.89998 11.5314 4.89998 12ZM4.84819 15.6962C5.26148 15.4201 5.82037 15.5313 6.09652 15.9445C6.35302 16.3284 6.64818 16.6891 6.97952 17.0204C7.31086 17.3518 7.67151 17.6469 8.0554 17.9034C8.46869 18.1796 8.57987 18.7385 8.30373 19.1518C8.02758 19.5651 7.46869 19.6762 7.0554 19.4001C6.57411 19.0785 6.12198 18.7085 5.70672 18.2932C5.29147 17.878 4.92144 17.4258 4.59986 16.9446C4.32372 16.5313 4.4349 15.9724 4.84819 15.6962ZM4.84819 8.30373C4.4349 8.02758 4.32372 7.46869 4.59986 7.0554C4.92144 6.57411 5.29147 6.12198 5.70673 5.70672C6.12198 5.29147 6.57411 4.92144 7.0554 4.59986C7.46869 4.32372 8.02759 4.4349 8.30373 4.84819C8.57987 5.26148 8.46869 5.82037 8.0554 6.09652C7.67151 6.35302 7.31086 6.64818 6.97952 6.97952C6.64818 7.31086 6.35302 7.67151 6.09652 8.0554C5.82038 8.46869 5.26148 8.57987 4.84819 8.30373ZM9.55654 19.6707C9.65352 19.1832 10.1273 18.8666 10.6148 18.9636C11.0677 19.0537 11.5314 19.1 12 19.1L12.0017 19.1C13.8841 19.0995 15.6893 18.3515 17.0204 17.0204C18.3519 15.6889 19.1 13.883 19.1 12C19.1 10.1169 18.3519 8.31103 17.0204 6.97952C15.6889 5.64801 13.883 4.89998 12 4.89997C11.5314 4.89997 11.0677 4.94629 10.6148 5.03637C10.1273 5.13334 9.65352 4.81676 9.55654 4.32926C9.45956 3.84175 9.77614 3.36794 10.2636 3.27096C10.8314 3.15802 11.4127 3.09998 12 3.09998L12.0008 3.09998C14.3609 3.1002 16.6243 4.03785 18.2932 5.70673C19.9623 7.3758 20.9 9.63955 20.9 12C20.9 14.3604 19.9623 16.6242 18.2932 18.2932C16.6242 19.9623 14.3604 20.9 12 20.9C11.4127 20.9 10.8314 20.8419 10.2636 20.729C9.77614 20.632 9.45956 20.1582 9.55654 19.6707ZM10.4261 14.6363C10.7775 14.9878 11.3474 14.9878 11.6988 14.6363L15.3349 11.0003C15.6864 10.6488 15.6864 10.079 15.3349 9.72751C14.9834 9.37604 14.4136 9.37604 14.0621 9.72751L11.0625 12.7272L9.63794 11.3026C9.28647 10.9512 8.71662 10.9512 8.36515 11.3026C8.01367 11.6541 8.01367 12.224 8.36515 12.5754L10.4261 14.6363Z"
      }
    )
  }
), T2 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  /* @__PURE__ */ e(
    "path",
    {
      d: "M7.49614 4.85494C6.82948 4.47399 6 4.95536 6 5.72318L6 18.2768C6 19.0446 6.82948 19.526 7.49614 19.1451L18.4806 12.8682C19.1524 12.4844 19.1524 11.5157 18.4806 11.1318L7.49614 4.85494Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ e("rect", { x: "22", y: "19", width: "2", height: "14", transform: "rotate(-180 22 19)", fill: "white" })
] }), O2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("circle", { cx: "12", cy: "12", r: "6", stroke: "#1A91F0", strokeWidth: "2", fill: "none" }),
      /* @__PURE__ */ e("circle", { cx: "12", cy: "12", r: "1", stroke: "#1A91F0", strokeWidth: "2", fill: "none" })
    ]
  }
), I2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M0.9 12C0.9 5.86964 5.86964 0.9 12 0.9C18.1304 0.9 23.1 5.86964 23.1 12C23.1 18.1304 18.1304 23.1 12 23.1C5.86964 23.1 0.9 18.1304 0.9 12Z",
          stroke: "#FB4458",
          fill: "none",
          strokeWidth: "1.8"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.698 15.9697C15.0495 16.3211 15.6193 16.3211 15.9708 15.9697C16.3222 15.6182 16.3222 15.0483 15.9708 14.6969L13.2728 11.9989L15.9687 9.303C16.3202 8.95153 16.3202 8.38168 15.9687 8.03021C15.6172 7.67873 15.0474 7.67873 14.6959 8.03021L12 10.7261L9.30411 8.03021C8.95263 7.67873 8.38278 7.67873 8.03131 8.03021C7.67984 8.38168 7.67984 8.95153 8.03131 9.303L10.7272 11.9989L8.02923 14.6969C7.67776 15.0483 7.67776 15.6182 8.02923 15.9697C8.3807 16.3211 8.95055 16.3211 9.30202 15.9697L12 13.2717L14.698 15.9697Z",
          fill: "#FB4458"
        }
      )
    ]
  }
), G2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    ...i,
    children: [
      /* @__PURE__ */ e("mask", { id: "path-1-inside-1_1886_32521", fill: "white", children: /* @__PURE__ */ e("rect", { x: "5.83325", y: "5.83398", width: "7", height: "7", rx: "1.12" }) }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "5.83325",
          y: "5.83398",
          width: "7",
          height: "7",
          rx: "1.12",
          stroke: "#9FA6BB",
          strokeWidth: "3.6",
          fill: "none",
          mask: "url(#path-1-inside-1_1886_32521)"
        }
      ),
      /* @__PURE__ */ e("mask", { id: "path-2-inside-2_1886_32521", fill: "white", children: /* @__PURE__ */ e("rect", { x: "5.83325", y: "15.166", width: "7", height: "7", rx: "1.12" }) }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "5.83325",
          y: "15.166",
          width: "7",
          height: "7",
          rx: "1.12",
          stroke: "#9FA6BB",
          strokeWidth: "3.6",
          fill: "none",
          mask: "url(#path-2-inside-2_1886_32521)"
        }
      ),
      /* @__PURE__ */ e("mask", { id: "path-3-inside-3_1886_32521", fill: "white", children: /* @__PURE__ */ e("rect", { x: "15.1667", y: "5.83398", width: "7", height: "7", rx: "1.12" }) }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "15.1667",
          y: "5.83398",
          width: "7",
          height: "7",
          rx: "1.12",
          stroke: "#9FA6BB",
          strokeWidth: "3.6",
          fill: "none",
          mask: "url(#path-3-inside-3_1886_32521)"
        }
      ),
      /* @__PURE__ */ e("mask", { id: "path-4-inside-4_1886_32521", fill: "white", children: /* @__PURE__ */ e("rect", { x: "15.1667", y: "15.166", width: "7", height: "7", rx: "1.12" }) }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "15.1667",
          y: "15.166",
          width: "7",
          height: "7",
          rx: "1.12",
          stroke: "#9FA6BB",
          strokeWidth: "3.6",
          fill: "none",
          mask: "url(#path-4-inside-4_1886_32521)"
        }
      )
    ]
  }
), P2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M19.2498 23.3327H8.74984C8.42767 23.3327 8.1665 23.0715 8.1665 22.7493V15.166V5.24935C8.1665 4.92718 8.42767 4.66602 8.74984 4.66602H13.9998L19.8332 10.4993V22.7493C19.8332 23.0715 19.572 23.3327 19.2498 23.3327Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M13.9998 4.66602H8.74984C8.42767 4.66602 8.1665 4.92718 8.1665 5.24935V15.166V22.7493C8.1665 23.0715 8.42767 23.3327 8.74984 23.3327H19.2498C19.572 23.3327 19.8332 23.0715 19.8332 22.7493V10.4993M13.9998 4.66602L19.8332 10.4993M13.9998 4.66602V9.91601C13.9998 10.2382 14.261 10.4993 14.5832 10.4993H19.8332",
          stroke: "#9FA6BB",
          strokeWidth: "1.8",
          strokeLinejoin: "round",
          fill: "none"
        }
      )
    ]
  }
), N2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4003 8.16693C11.4003 7.37532 12.0421 6.73359 12.8337 6.73359H15.167C15.9586 6.73359 16.6003 7.37532 16.6003 8.16693H11.4003ZM9.60033 8.16693H7.00033C5.71166 8.16693 4.66699 9.2116 4.66699 10.5003V12.6569V13.5569V14.4569V18.6669C4.66699 19.9556 5.71166 21.0003 7.00032 21.0003H21.0003C22.289 21.0003 23.3337 19.9556 23.3337 18.6669V14.4569V13.5569V12.6569V10.5003C23.3337 9.2116 22.289 8.16693 21.0003 8.16693H18.4003C18.4003 6.38121 16.9527 4.93359 15.167 4.93359H12.8337C11.0479 4.93359 9.60033 6.38121 9.60033 8.16693ZM21.5337 12.6569H6.46699V10.5003C6.46699 10.2057 6.70577 9.96693 7.00033 9.96693H21.0003C21.2949 9.96693 21.5337 10.2057 21.5337 10.5003V12.6569ZM21.5337 18.6669V14.4569H6.46699V18.6669C6.46699 18.9615 6.70577 19.2003 7.00032 19.2003H21.0003C21.2949 19.2003 21.5337 18.9615 21.5337 18.6669Z",
        fill: "#9FA6BB"
      }
    )
  }
), J2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "rect",
        {
          x: "5.83496",
          y: "5.83008",
          width: "6.41667",
          height: "8.16667",
          rx: "0.7",
          stroke: "#9FA6BB",
          strokeWidth: "1.8",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "15.75",
          y: "14",
          width: "6.41667",
          height: "8.16667",
          rx: "0.7",
          stroke: "#9FA6BB",
          strokeWidth: "1.8",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "15.75",
          y: "5.83008",
          width: "6.41667",
          height: "4.66667",
          rx: "0.7",
          stroke: "#9FA6BB",
          strokeWidth: "1.8",
          strokeLinejoin: "round",
          fill: "none"
        }
      ),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "5.83496",
          y: "17.5",
          width: "6.41667",
          height: "4.66667",
          rx: "0.7",
          stroke: "#9FA6BB",
          strokeWidth: "1.8",
          strokeLinejoin: "round",
          fill: "none"
        }
      )
    ]
  }
), Q2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.83333 11.6673C7.122 11.6673 8.16667 12.712 8.16667 14.0006C8.16667 15.2893 7.122 16.334 5.83333 16.334C4.54467 16.334 3.5 15.2893 3.5 14.0006C3.5 12.712 4.54467 11.6673 5.83333 11.6673ZM14.0002 11.6673C15.2889 11.6673 16.3336 12.712 16.3336 14.0006C16.3336 15.2893 15.2889 16.334 14.0002 16.334C12.7116 16.334 11.6669 15.2893 11.6669 14.0006C11.6669 12.712 12.7116 11.6673 14.0002 11.6673ZM24.4998 14.0006C24.4998 12.712 23.4551 11.6673 22.1664 11.6673C20.8778 11.6673 19.8331 12.712 19.8331 14.0006C19.8331 15.2893 20.8778 16.334 22.1664 16.334C23.4551 16.334 24.4998 15.2893 24.4998 14.0006Z",
        fill: "#9FA6BB"
      }
    )
  }
), Y2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("rect", { width: "28", height: "28", fill: "white" }),
      /* @__PURE__ */ e("mask", { id: "path-1-inside-1_1997_30415", fill: "white", children: /* @__PURE__ */ e("rect", { x: "5.8335", y: "5.83398", width: "7", height: "7", rx: "1.16667" }) }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "5.8335",
          y: "5.83398",
          width: "7",
          height: "7",
          rx: "1.16667",
          fill: "#1A91F0",
          stroke: "#1A91F0",
          strokeWidth: "4.2",
          mask: "url(#path-1-inside-1_1997_30415)"
        }
      ),
      /* @__PURE__ */ e("mask", { id: "path-2-inside-2_1997_30415", fill: "white", children: /* @__PURE__ */ e("rect", { x: "5.8335", y: "15.166", width: "7", height: "7", rx: "1.16667" }) }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "5.8335",
          y: "15.166",
          width: "7",
          height: "7",
          rx: "1.16667",
          fill: "#1A91F0",
          stroke: "#1A91F0",
          strokeWidth: "4.2",
          mask: "url(#path-2-inside-2_1997_30415)"
        }
      ),
      /* @__PURE__ */ e("mask", { id: "path-3-inside-3_1997_30415", fill: "white", children: /* @__PURE__ */ e("rect", { x: "15.1665", y: "5.83398", width: "7", height: "7", rx: "1.16667" }) }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "15.1665",
          y: "5.83398",
          width: "7",
          height: "7",
          rx: "1.16667",
          fill: "#1A91F0",
          stroke: "#1A91F0",
          strokeWidth: "4.2",
          mask: "url(#path-3-inside-3_1997_30415)"
        }
      ),
      /* @__PURE__ */ e("mask", { id: "path-4-inside-4_1997_30415", fill: "white", children: /* @__PURE__ */ e("rect", { x: "15.1665", y: "15.166", width: "7", height: "7", rx: "1.16667" }) }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "15.1665",
          y: "15.166",
          width: "7",
          height: "7",
          rx: "1.16667",
          fill: "#1A91F0",
          stroke: "#1A91F0",
          strokeWidth: "4.2",
          mask: "url(#path-4-inside-4_1997_30415)"
        }
      )
    ]
  }
), q2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("rect", { width: "28", height: "28", fill: "white" }),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M19.2484 23.3366H8.74837C8.42621 23.3366 8.16504 23.0754 8.16504 22.7533V15.1699V5.25325C8.16504 4.93109 8.42621 4.66992 8.74837 4.66992H13.9984L19.8317 10.5033V22.7533C19.8317 23.0754 19.5705 23.3366 19.2484 23.3366Z",
          fill: "#1A91F0"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M13.9984 4.66992H8.74837C8.42621 4.66992 8.16504 4.93109 8.16504 5.25325V15.1699V22.7533C8.16504 23.0754 8.42621 23.3366 8.74837 23.3366H19.2484C19.5705 23.3366 19.8317 23.0754 19.8317 22.7533V10.5033M13.9984 4.66992L19.8317 10.5033M13.9984 4.66992V9.91992C13.9984 10.2421 14.2595 10.5033 14.5817 10.5033H19.8317",
          stroke: "#1A91F0",
          fill: "#1A91F0",
          strokeWidth: "1.96",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M14 9.91628V5.59961L18.9 10.4996H14.5833C14.2612 10.4996 14 10.2384 14 9.91628Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "1.96",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), K2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("rect", { width: "28", height: "28", fill: "white" }),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.4003 8.16693C11.4003 7.37532 12.0421 6.73359 12.8337 6.73359H15.167C15.9586 6.73359 16.6003 7.37532 16.6003 8.16693H11.4003ZM9.60033 8.16693L7.00033 8.16693C5.71166 8.16693 4.66699 9.2116 4.66699 10.5003V13.5569V18.6669C4.66699 19.9556 5.71166 21.0003 7.00032 21.0003H21.0003C22.289 21.0003 23.3337 19.9556 23.3337 18.6669V13.5569V10.5003C23.3337 9.2116 22.289 8.16693 21.0003 8.16693L18.4003 8.16693C18.4003 6.38121 16.9527 4.93359 15.167 4.93359H12.8337C11.0479 4.93359 9.60033 6.38121 9.60033 8.16693Z",
          fill: "#1A91F0"
        }
      ),
      /* @__PURE__ */ e("path", { d: "M4.66699 13.5566H23.3337", stroke: "white", strokeWidth: "1.8" })
    ]
  }
), X2 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("rect", { width: "28", height: "28", fill: "white" }),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "5.83496",
          y: "5.83008",
          width: "6.41667",
          height: "8.16667",
          rx: "0.7",
          fill: "#1A91F0",
          stroke: "#1A91F0",
          strokeWidth: "1.96",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "15.75",
          y: "14",
          width: "6.41667",
          height: "8.16667",
          rx: "0.7",
          fill: "#1A91F0",
          stroke: "#1A91F0",
          strokeWidth: "1.96",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "15.75",
          y: "5.83008",
          width: "6.41667",
          height: "4.66667",
          rx: "0.7",
          fill: "#1A91F0",
          stroke: "#1A91F0",
          strokeWidth: "1.96",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "rect",
        {
          x: "5.83496",
          y: "17.5",
          width: "6.41667",
          height: "4.66667",
          rx: "0.7",
          fill: "#1A91F0",
          stroke: "#1A91F0",
          strokeWidth: "1.96",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), $2 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M9.5 7L14.5 12L9.5 17",
        stroke: "#1A91F0",
        strokeWidth: "1.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
      }
    )
  }
), e0 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...i,
    children: /* @__PURE__ */ e("g", { id: "24x24/Menu", children: /* @__PURE__ */ e(
      "path",
      {
        id: "Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 5C3.5 4.17157 4.17157 3.5 5 3.5C5.82843 3.5 6.5 4.17157 6.5 5C6.5 5.82843 5.82843 6.5 5 6.5C4.17157 6.5 3.5 5.82843 3.5 5ZM3.5 12C3.5 11.1716 4.17157 10.5 5 10.5C5.82843 10.5 6.5 11.1716 6.5 12C6.5 12.8284 5.82843 13.5 5 13.5C4.17157 13.5 3.5 12.8284 3.5 12ZM5 17.5C4.17157 17.5 3.5 18.1716 3.5 19C3.5 19.8284 4.17157 20.5 5 20.5C5.82843 20.5 6.5 19.8284 6.5 19C6.5 18.1716 5.82843 17.5 5 17.5ZM10.5 5C10.5 4.17157 11.1716 3.5 12 3.5C12.8284 3.5 13.5 4.17157 13.5 5C13.5 5.82843 12.8284 6.5 12 6.5C11.1716 6.5 10.5 5.82843 10.5 5ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5ZM10.5 19C10.5 18.1716 11.1716 17.5 12 17.5C12.8284 17.5 13.5 18.1716 13.5 19C13.5 19.8284 12.8284 20.5 12 20.5C11.1716 20.5 10.5 19.8284 10.5 19ZM19 3.5C18.1716 3.5 17.5 4.17157 17.5 5C17.5 5.82843 18.1716 6.5 19 6.5C19.8284 6.5 20.5 5.82843 20.5 5C20.5 4.17157 19.8284 3.5 19 3.5ZM17.5 12C17.5 11.1716 18.1716 10.5 19 10.5C19.8284 10.5 20.5 11.1716 20.5 12C20.5 12.8284 19.8284 13.5 19 13.5C18.1716 13.5 17.5 12.8284 17.5 12ZM19 17.5C18.1716 17.5 17.5 18.1716 17.5 19C17.5 19.8284 18.1716 20.5 19 20.5C19.8284 20.5 20.5 19.8284 20.5 19C20.5 18.1716 19.8284 17.5 19 17.5Z",
        fill: "currentColor"
      }
    ) })
  }
), i0 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e("rect", { width: "24", height: "24", fill: "white" }),
      /* @__PURE__ */ e(
        "circle",
        {
          cx: "12",
          cy: "12",
          r: "6",
          fill: "white",
          stroke: "#0F141E",
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e("circle", { cx: "12", cy: "12", r: "1", fill: "white", stroke: "black", strokeWidth: "2" }),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M18 12H20",
          stroke: "#0F141E",
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M4 12H6",
          stroke: "#0F141E",
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M12 6V4",
          stroke: "#0F141E",
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M12 20V18",
          stroke: "#0F141E",
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), t0 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  /* @__PURE__ */ e(
    "path",
    {
      fill: "#828BA2",
      d: "M12.7 8a.7.7 0 1 0-1.4 0v4.5a.7.7 0 0 0 .34.6l2.5 1.5a.7.7 0 0 0 .72-1.2l-2.16-1.296V8Z"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      fill: "#828BA2",
      fillRule: "evenodd",
      d: "M20.7 12A8.699 8.699 0 0 0 3.962 8.67 8.7 8.7 0 1 0 20.7 12Zm-1.956-2.794a7.301 7.301 0 1 1-13.49 5.588 7.301 7.301 0 0 1 13.49-5.588Z",
      clipRule: "evenodd"
    }
  )
] }), C0 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fill: "#828BA2",
    fillRule: "evenodd",
    d: "M4 7.4h16a.6.6 0 0 1 .6.6v8a.6.6 0 0 1-.6.6H4a.6.6 0 0 1-.6-.6V8a.6.6 0 0 1 .6-.6ZM2 8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8Zm8.7 4a1.3 1.3 0 1 1 2.6 0 1.3 1.3 0 0 1-2.6 0ZM12 9.3a2.7 2.7 0 1 0 0 5.4 2.7 2.7 0 0 0 0-5.4Zm6 2.7a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  }
) }), h0 = (i) => /* @__PURE__ */ t("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: [
  /* @__PURE__ */ e(
    "path",
    {
      stroke: "#1A91F0",
      strokeWidth: 1.8,
      fill: "white",
      d: "M13.037 6.134a.5.5 0 0 1 .926 0l1.632 3.997a.5.5 0 0 0 .274.274l3.997 1.632a.5.5 0 0 1 0 .926l-3.997 1.632a.5.5 0 0 0-.274.274l-1.632 3.997a.5.5 0 0 1-.926 0l-1.632-3.997a.5.5 0 0 0-.274-.274l-3.997-1.632a.5.5 0 0 1 0-.926l3.997-1.632a.5.5 0 0 0 .274-.274l1.632-3.997Z"
    }
  ),
  /* @__PURE__ */ e(
    "path",
    {
      fill: "#1A91F0",
      d: "M6.016 3.877c.129-.5.84-.5.968 0l.365 1.415a.5.5 0 0 0 .36.359l1.414.365c.5.129.5.84 0 .968l-1.415.365a.5.5 0 0 0-.359.36l-.365 1.414c-.129.5-.84.5-.968 0L5.65 7.708a.5.5 0 0 0-.36-.359l-1.414-.365c-.5-.129-.5-.84 0-.968l1.415-.365a.5.5 0 0 0 .359-.36l.365-1.414Z"
    }
  )
] }), l0 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    stroke: "#1A91F0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M6 19h12M7.5 9.5l4.126 4.58a.5.5 0 0 0 .748 0L16.5 9.5M12 3v11"
  }
) }), o0 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M13.6686 8.66846L17.0029 12.0027M17.0029 12.0027L13.6686 15.337M17.0029 12.0027H7",
        stroke: "#0F3871",
        strokeWidth: "1.2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), d0 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9714 9.57137C16.9714 7.42959 15.4656 5.63952 13.4549 5.20213C13.3281 4.79532 12.9485 4.5 12.5 4.5C12.0514 4.5 11.6719 4.79532 11.5451 5.20213C9.5344 5.63952 8.02856 7.42959 8.02856 9.57137V13.3521C8.02856 13.7976 7.92135 14.2365 7.71599 14.6318L6.85312 16.2929C6.47272 17.0251 7.00409 17.8999 7.82926 17.8999H10.5404C10.6182 18.2813 10.8064 18.6348 11.0858 18.9142C11.4608 19.2893 11.9696 19.5 12.5 19.5C13.0304 19.5 13.5391 19.2893 13.9142 18.9142C14.1936 18.6348 14.3818 18.2813 14.4596 17.8999H17.1707C17.9959 17.8999 18.5273 17.0251 18.1469 16.2929L17.284 14.6318C17.0786 14.2365 16.9714 13.7976 16.9714 13.3521V9.57137ZM12.5 6.89994C11.0246 6.89994 9.82856 8.09598 9.82856 9.57137V13.3521C9.82856 14.0864 9.65184 14.8099 9.31332 15.4616L8.98171 16.0999H16.0183L15.6867 15.4616C15.3481 14.8099 15.1714 14.0864 15.1714 13.3521V9.57137C15.1714 8.09598 13.9754 6.89994 12.5 6.89994Z",
        fill: "#1A91F0"
      }
    )
  }
), n0 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, fill: "none", children: [
  /* @__PURE__ */ e(
    "path",
    {
      stroke: "currentColor",
      strokeWidth: 1.8,
      d: "M7.83 17h9.34a.2.2 0 0 0 .178-.292l-.863-1.661a3.677 3.677 0 0 1-.414-1.695v-3.78a3.571 3.571 0 0 0-7.142 0v3.78c0 .59-.142 1.171-.414 1.695l-.863 1.66a.2.2 0 0 0 .177.293Z"
    }
  ),
  /* @__PURE__ */ e("circle", { cx: 12.5, cy: 5.5, r: 1, fill: "currentColor", transform: "rotate(-180 12.5 5.5)" }),
  /* @__PURE__ */ e("path", { fill: "currentColor", d: "M14.5 17.5a2 2 0 0 1-4 0h4Z" })
] }) }), s0 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M19 7H4L8.5 11.5V18L19 7Z",
        stroke: "currentColor",
        fill: "transparent",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), r0 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: [
      /* @__PURE__ */ t("g", { clipPath: "url(#clip0_157_43092)", children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M21.6617 17.864C21.3417 18.0313 21.0117 18.1788 20.6736 18.3055C19.5974 18.7082 18.4573 18.9134 17.3082 18.9111C12.8722 18.9111 9.0081 15.8598 9.0081 11.9441C9.01378 11.4189 9.15952 10.9047 9.43028 10.4547C9.70103 10.0046 10.087 9.63498 10.5483 9.38391C6.53607 9.55265 5.50488 13.7336 5.50488 16.1832C5.50488 23.109 11.8879 23.8111 13.2631 23.8111C14.0047 23.8111 15.123 23.5955 15.7942 23.3837L15.917 23.3424C18.4999 22.4495 20.7018 20.7038 22.1604 18.3927C22.2051 18.3223 22.225 18.2391 22.2171 18.1561C22.2092 18.0731 22.1738 17.9951 22.1166 17.9345C22.0594 17.8738 21.9836 17.834 21.9012 17.8212C21.8188 17.8085 21.7346 17.8235 21.6617 17.864Z",
            fill: "url(#paint0_linear_157_43092)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            opacity: "0.35",
            d: "M21.6617 17.864C21.3417 18.0313 21.0117 18.1788 20.6736 18.3055C19.5974 18.7082 18.4573 18.9134 17.3082 18.9111C12.8722 18.9111 9.0081 15.8598 9.0081 11.9441C9.01378 11.4189 9.15952 10.9047 9.43028 10.4547C9.70103 10.0046 10.087 9.63498 10.5483 9.38391C6.53607 9.55265 5.50488 13.7336 5.50488 16.1832C5.50488 23.109 11.8879 23.8111 13.2631 23.8111C14.0047 23.8111 15.123 23.5955 15.7942 23.3837L15.917 23.3424C18.4999 22.4495 20.7018 20.7038 22.1604 18.3927C22.2051 18.3223 22.225 18.2391 22.2171 18.1561C22.2092 18.0731 22.1738 17.9951 22.1166 17.9345C22.0594 17.8738 21.9836 17.834 21.9012 17.8212C21.8188 17.8085 21.7346 17.8235 21.6617 17.864Z",
            fill: "url(#paint1_radial_157_43092)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M9.91249 22.6338C9.07635 22.1148 8.35172 21.4348 7.78075 20.6333C7.12996 19.7416 6.68213 18.7184 6.46866 17.6354C6.2552 16.5524 6.28126 15.4358 6.54504 14.3639C6.80881 13.292 7.3039 12.2908 7.99558 11.4306C8.68726 10.5703 9.55878 9.87175 10.549 9.38396C10.8415 9.24616 11.3411 8.9968 12.0058 9.00899C12.4741 9.0124 12.9352 9.1242 13.353 9.33563C13.7708 9.54706 14.134 9.85238 14.4141 10.2277C14.7926 10.7331 15.0014 11.3455 15.0103 11.9769C15.0103 11.9572 17.3033 4.51489 7.51076 4.51489C3.39539 4.51489 0.0112315 8.42027 0.0112315 11.8466C-0.00500126 13.6591 0.382808 15.4525 1.14647 17.0963C2.39451 19.7592 4.577 21.871 7.27949 23.0308C9.98198 24.1905 13.0163 24.3175 15.8062 23.3875C14.8293 23.6955 13.7973 23.7879 12.7812 23.6584C11.7652 23.529 10.7893 23.1806 9.92093 22.6375L9.91249 22.6338Z",
            fill: "url(#paint2_linear_157_43092)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            opacity: "0.41",
            d: "M9.91249 22.6338C9.07635 22.1148 8.35172 21.4348 7.78075 20.6333C7.12996 19.7416 6.68213 18.7184 6.46866 17.6354C6.2552 16.5524 6.28126 15.4358 6.54504 14.3639C6.80881 13.292 7.3039 12.2908 7.99558 11.4306C8.68726 10.5703 9.55878 9.87175 10.549 9.38396C10.8415 9.24616 11.3411 8.9968 12.0058 9.00899C12.4741 9.0124 12.9352 9.1242 13.353 9.33563C13.7708 9.54706 14.134 9.85238 14.4141 10.2277C14.7926 10.7331 15.0014 11.3455 15.0103 11.9769C15.0103 11.9572 17.3033 4.51489 7.51076 4.51489C3.39539 4.51489 0.0112315 8.42027 0.0112315 11.8466C-0.00500126 13.6591 0.382808 15.4525 1.14647 17.0963C2.39451 19.7592 4.577 21.871 7.27949 23.0308C9.98198 24.1905 13.0163 24.3175 15.8062 23.3875C14.8293 23.6955 13.7973 23.7879 12.7812 23.6584C11.7652 23.529 10.7893 23.1806 9.92093 22.6375L9.91249 22.6338Z",
            fill: "url(#paint3_radial_157_43092)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M14.28 13.9567C14.2041 14.0551 13.9707 14.1911 13.9707 14.4873C13.9707 14.732 14.1301 14.9673 14.4132 15.1651C15.7612 16.1025 18.3026 15.9788 18.3092 15.9788C19.308 15.9764 20.288 15.7061 21.1468 15.196C22.0132 14.6901 22.7323 13.9665 23.2326 13.0969C23.733 12.2274 23.9974 11.2421 23.9994 10.2388C24.0238 8.13801 23.2495 6.74122 22.9364 6.12251C20.9499 2.23681 16.6621 0.00195318 11.9993 0.00195318C8.84587 0.00164137 5.81911 1.24266 3.5736 3.45659C1.3281 5.67052 0.0443444 8.6794 0 11.8325C0.0449972 8.40705 3.44978 5.64066 7.49953 5.64066C7.82764 5.64066 9.69877 5.67254 11.4368 6.58467C12.9686 7.38899 13.771 8.36018 14.3288 9.32293C14.9081 10.3232 15.0113 11.5869 15.0113 12.0903C15.0113 12.5937 14.7544 13.3399 14.28 13.9567Z",
            fill: "url(#paint4_radial_157_43092)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M14.28 13.9567C14.2041 14.0551 13.9707 14.1911 13.9707 14.4873C13.9707 14.732 14.1301 14.9673 14.4132 15.1651C15.7612 16.1025 18.3026 15.9788 18.3092 15.9788C19.308 15.9764 20.288 15.7061 21.1468 15.196C22.0132 14.6901 22.7323 13.9665 23.2326 13.0969C23.733 12.2274 23.9974 11.2421 23.9994 10.2388C24.0238 8.13801 23.2495 6.74122 22.9364 6.12251C20.9499 2.23681 16.6621 0.00195318 11.9993 0.00195318C8.84587 0.00164137 5.81911 1.24266 3.5736 3.45659C1.3281 5.67052 0.0443444 8.6794 0 11.8325C0.0449972 8.40705 3.44978 5.64066 7.49953 5.64066C7.82764 5.64066 9.69877 5.67254 11.4368 6.58467C12.9686 7.38899 13.771 8.36018 14.3288 9.32293C14.9081 10.3232 15.0113 11.5869 15.0113 12.0903C15.0113 12.5937 14.7544 13.3399 14.28 13.9567Z",
            fill: "url(#paint5_radial_157_43092)"
          }
        )
      ] }),
      /* @__PURE__ */ t("defs", { children: [
        /* @__PURE__ */ t(
          "linearGradient",
          {
            id: "paint0_linear_157_43092",
            x1: "5.50488",
            y1: "16.5994",
            x2: "22.2232",
            y2: "16.5994",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ e("stop", { stopColor: "#0C59A4" }),
              /* @__PURE__ */ e("stop", { offset: "1", stopColor: "#114A8B" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "paint1_radial_157_43092",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(14.7387 16.7312) scale(8.94132 8.49425)",
            children: [
              /* @__PURE__ */ e("stop", { offset: "0.72", stopOpacity: "0" }),
              /* @__PURE__ */ e("stop", { offset: "0.95", stopOpacity: "0.53" }),
              /* @__PURE__ */ e("stop", { offset: "1" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "linearGradient",
          {
            id: "paint2_linear_157_43092",
            x1: "14.3194",
            y1: "9.3474",
            x2: "3.87724",
            y2: "20.7214",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ e("stop", { stopColor: "#1B9DE2" }),
              /* @__PURE__ */ e("stop", { offset: "0.16", stopColor: "#1595DF" }),
              /* @__PURE__ */ e("stop", { offset: "0.67", stopColor: "#0680D7" }),
              /* @__PURE__ */ e("stop", { offset: "1", stopColor: "#0078D4" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "paint3_radial_157_43092",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(6.61874 18.6579) rotate(-81.3844) scale(13.4454 10.8625)",
            children: [
              /* @__PURE__ */ e("stop", { offset: "0.76", stopOpacity: "0" }),
              /* @__PURE__ */ e("stop", { offset: "0.95", stopOpacity: "0.5" }),
              /* @__PURE__ */ e("stop", { offset: "1" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "paint4_radial_157_43092",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(2.42446 4.44325) rotate(92.2906) scale(18.9918 40.4486)",
            children: [
              /* @__PURE__ */ e("stop", { stopColor: "#35C1F1" }),
              /* @__PURE__ */ e("stop", { offset: "0.11", stopColor: "#34C1ED" }),
              /* @__PURE__ */ e("stop", { offset: "0.23", stopColor: "#2FC2DF" }),
              /* @__PURE__ */ e("stop", { offset: "0.31", stopColor: "#2BC3D2" }),
              /* @__PURE__ */ e("stop", { offset: "0.67", stopColor: "#36C752" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "radialGradient",
          {
            id: "paint5_radial_157_43092",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(22.5054 7.25832) rotate(73.7398) scale(9.12506 7.42049)",
            children: [
              /* @__PURE__ */ e("stop", { stopColor: "#66EB6E" }),
              /* @__PURE__ */ e("stop", { offset: "1", stopColor: "#66EB6E", stopOpacity: "0" })
            ]
          }
        ),
        /* @__PURE__ */ e("clipPath", { id: "clip0_157_43092", children: /* @__PURE__ */ e("rect", { width: "24", height: "24", fill: "white", transform: "translate(0 0.00195312)" }) })
      ] })
    ]
  }
), a0 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "24",
    viewBox: "0 0 22 24",
    fill: "none",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M20.7527 5.75176L21.3319 4.3689C21.3319 4.3689 20.6032 3.60468 19.7064 2.73129C18.8096 1.8579 16.9226 2.36738 16.9226 2.36738L14.774 0.00195312H7.22598L5.05872 2.38558C5.05872 2.38558 3.17171 1.8761 2.27491 2.74949C1.37811 3.62288 0.649466 4.38709 0.649466 4.38709L1.22865 5.76996L0.5 7.80787C0.5 7.80787 2.66726 15.7775 2.91014 16.7601C3.41459 18.6706 3.75089 19.4167 5.17082 20.3992C6.59075 21.3818 9.15036 23.0558 9.58007 23.3105C9.9911 23.5653 10.5329 24.002 11 24.002C11.4671 24.002 11.9902 23.5653 12.4199 23.3105C12.831 23.0558 15.4093 21.3636 16.8292 20.3992C18.2491 19.4349 18.5854 18.6888 19.0899 16.7601C19.3514 15.7775 21.5 7.80787 21.5 7.80787L20.7527 5.75176Z",
          fill: "url(#paint0_linear_314_315)"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M16.3232 3.89596C16.3232 3.89596 19.0883 7.15297 19.0883 7.8626C19.0883 8.57223 18.7333 8.73599 18.3783 9.0999C18.0234 9.46381 16.4913 11.0468 16.3045 11.247C16.099 11.4471 15.7066 11.7565 15.9308 12.3205C16.1737 12.8664 16.5287 13.576 16.1363 14.3038C15.744 15.0135 15.0714 15.5048 14.6417 15.4138C14.212 15.341 13.1844 14.8133 12.8107 14.5768C12.4371 14.3402 11.26 13.3941 11.26 13.0302C11.26 12.6662 12.4931 12.0112 12.7173 11.8656C12.9415 11.7201 13.9691 11.1378 13.9878 10.9195C14.0065 10.7011 14.0065 10.6283 13.6888 10.0643C13.3899 9.5002 12.8294 8.75419 12.9228 8.2629C13.0162 7.77162 13.8944 7.51688 14.5296 7.28034C15.1648 7.0438 16.3792 6.6071 16.5287 6.53432C16.6782 6.46154 16.6408 6.40695 16.1737 6.35237C15.7066 6.31597 14.4175 6.13402 13.8196 6.29778C13.2218 6.46154 12.2315 6.69808 12.1381 6.82545C12.0634 6.95282 11.9887 6.95282 12.0634 7.40771C12.1381 7.84441 12.5865 9.99149 12.6239 10.3736C12.6613 10.7557 12.7547 11.0104 12.325 11.1014C11.9139 11.1924 11.204 11.3562 10.9611 11.3562C10.7182 11.3562 10.0082 11.1924 9.5972 11.1014C9.18617 11.0104 9.2609 10.7557 9.29827 10.3736C9.33563 9.99149 9.76535 7.8626 9.85877 7.40771C9.9335 6.97102 9.87745 6.95282 9.78403 6.82545C9.7093 6.69808 8.7004 6.46154 8.10254 6.29778C7.50467 6.13402 6.21553 6.29778 5.74845 6.35237C5.28136 6.38876 5.244 6.46154 5.39346 6.53432C5.54293 6.6071 6.75734 7.0438 7.39257 7.28034C8.02781 7.51688 8.90592 7.77162 8.99934 8.2629C9.09275 8.75419 8.55094 9.5002 8.23332 10.0643C7.93439 10.6283 7.91571 10.6829 7.93439 10.9195C7.95307 11.1378 8.98065 11.7201 9.20485 11.8656C9.42905 12.0112 10.6621 12.6662 10.6621 13.0302C10.6621 13.3941 9.4851 14.3402 9.11144 14.5768C8.73777 14.8133 7.72887 15.3228 7.28047 15.4138C6.85076 15.4866 6.17816 15.0135 5.78581 14.3038C5.39346 13.5942 5.74845 12.8846 5.99133 12.3205C6.23421 11.7747 5.82318 11.4653 5.61766 11.247C5.41215 11.0468 3.8988 9.46381 3.54382 9.0999C3.18884 8.73599 2.85254 8.55403 2.85254 7.8626C2.85254 7.17117 5.61766 3.89596 5.61766 3.89596C5.61766 3.89596 7.95307 4.33265 8.27069 4.33265C8.5883 4.33265 9.2609 4.07792 9.89613 3.87776C10.5314 3.67761 10.9424 3.67761 10.9424 3.67761C10.9424 3.67761 11.3534 3.67761 11.9887 3.87776C12.6239 4.07792 13.2965 4.33265 13.6141 4.33265C13.9317 4.33265 16.3232 3.89596 16.3232 3.89596ZM14.2493 16.3599C14.4175 16.4691 14.3241 16.6693 14.1559 16.7602C14.0065 16.8694 11.8952 18.4524 11.7084 18.6344C11.5029 18.8164 11.204 19.0893 10.9984 19.0893C10.7929 19.0893 10.494 18.7982 10.2885 18.6344C10.083 18.4524 7.99044 16.8694 7.84097 16.7602C7.69151 16.6511 7.57941 16.4509 7.74756 16.3599C7.91571 16.2508 8.45752 15.996 9.18617 15.6139C9.9335 15.2318 10.849 14.9225 10.9984 14.9225C11.1479 14.9225 12.0634 15.2318 12.8107 15.6139C13.5394 15.996 14.0812 16.269 14.2493 16.3599Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M16.9231 2.38558L14.7745 0.00195312H7.22646L5.0592 2.38558C5.0592 2.38558 3.17219 1.8761 2.27539 2.74949C2.27539 2.74949 4.79763 2.53114 5.65706 3.89581C5.65706 3.89581 7.99247 4.33251 8.31009 4.33251C8.6277 4.33251 9.3003 4.07777 9.93553 3.87762C10.5708 3.67746 10.9818 3.67747 10.9818 3.67747C10.9818 3.67747 11.3928 3.67746 12.0281 3.87762C12.6633 4.07777 13.3359 4.33251 13.6535 4.33251C13.9711 4.33251 16.3065 3.89581 16.3065 3.89581C17.166 2.53114 19.6882 2.74949 19.6882 2.74949C18.8101 1.8761 16.9231 2.38558 16.9231 2.38558Z",
          fill: "url(#paint1_linear_314_315)"
        }
      ),
      /* @__PURE__ */ t("defs", { children: [
        /* @__PURE__ */ t(
          "linearGradient",
          {
            id: "paint0_linear_314_315",
            x1: "0.5123",
            y1: "11.9966",
            x2: "21.4959",
            y2: "11.9966",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ e("stop", { stopColor: "#FF5500" }),
              /* @__PURE__ */ e("stop", { offset: "0.41", stopColor: "#FF5500" }),
              /* @__PURE__ */ e("stop", { offset: "0.582", stopColor: "#FF2000" }),
              /* @__PURE__ */ e("stop", { offset: "1", stopColor: "#FF2000" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "linearGradient",
          {
            id: "paint1_linear_314_315",
            x1: "2.66454",
            y1: "2.15986",
            x2: "19.7152",
            y2: "2.15986",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ e("stop", { stopColor: "#FF452A" }),
              /* @__PURE__ */ e("stop", { offset: "1", stopColor: "#FF2000" })
            ]
          }
        )
      ] })
    ]
  }
), L0 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ t("g", { id: "24x24/ArrowTarget", children: [
      /* @__PURE__ */ e(
        "path",
        {
          id: "Ellipse",
          d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4",
          stroke: "white",
          strokeWidth: "1.4",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          id: "Line 4",
          d: "M11.9982 11.9977L13.8429 10.1531M13.8429 10.1531L13.644 7.30269C13.6239 7.01395 13.7298 6.73065 13.9345 6.52599L17.3015 3.15891L17.2247 6.77131L20.8371 6.69445L17.47 10.0615C17.2653 10.2662 16.982 10.3721 16.6933 10.352L13.8429 10.1531Z",
          stroke: "white",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          id: "Ellipse 148",
          d: "M10.7639 8.19577C10.1029 8.41056 9.50925 8.79387 9.04148 9.30795C8.5737 9.82203 8.24795 10.4491 8.09633 11.1274C7.94471 11.8057 7.97246 12.5118 8.17683 13.1762C8.3812 13.8405 8.75515 14.4401 9.26181 14.9159C9.76848 15.3917 10.3904 15.7272 11.0662 15.8895C11.7421 16.0517 12.4485 16.0351 13.116 15.8412C13.7834 15.6473 14.3888 15.2828 14.8725 14.7837C15.3562 14.2845 15.7015 13.668 15.8743 12.9948",
          stroke: "white",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ] })
  }
), c0 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.0266 7.08281C12.8805 7.22883 12.8049 7.43097 12.8193 7.63698L12.9722 9.82796L15.1632 9.98082C15.3692 9.99519 15.5713 9.9196 15.7173 9.77357L17.6463 7.84458L16.0136 7.87932C15.7219 7.88553 15.4403 7.77239 15.234 7.56609C15.0278 7.3598 14.9146 7.07823 14.9208 6.78655L14.9556 5.15382L13.0266 7.08281ZM10.8677 10.4189L10.684 7.78596C10.6265 6.96191 10.9289 6.15336 11.513 5.56925L15.3254 1.75683C15.6345 1.44781 16.1003 1.35771 16.5023 1.52924C16.9042 1.70076 17.1615 2.09945 17.1522 2.53637L17.0846 5.71556L20.2638 5.64792C20.7007 5.63862 21.0994 5.89591 21.2709 6.29786C21.4424 6.69981 21.3523 7.16568 21.0433 7.4747L17.2309 11.2871C16.6468 11.8712 15.8382 12.1736 15.0142 12.1161L12.3813 11.9324L10.5325 13.7812C10.1146 14.1991 9.43693 14.1991 9.01897 13.7812C8.60101 13.3632 8.60101 12.6856 9.01897 12.2676L10.8677 10.4189Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.03221 7.26814C9.21487 7.83029 8.90723 8.43407 8.34508 8.61672C7.57866 8.86575 6.89036 9.31018 6.34801 9.90621C5.80566 10.5023 5.42797 11.2293 5.25218 12.0158C5.07639 12.8022 5.10855 13.6209 5.34551 14.3911C5.58246 15.1614 6.01603 15.8566 6.60347 16.4082C7.19092 16.9599 7.91197 17.3489 8.69556 17.537C9.47915 17.7252 10.2982 17.7059 11.0721 17.481C11.846 17.2562 12.5479 16.8336 13.1087 16.2549C13.6695 15.6762 14.0698 14.9614 14.2702 14.1808C14.4172 13.6083 15.0005 13.2634 15.573 13.4104C16.1455 13.5574 16.4905 14.1406 16.3435 14.7131C16.0506 15.8539 15.4655 16.8987 14.6458 17.7445C13.8262 18.5903 12.8003 19.2079 11.6693 19.5365C10.5382 19.8651 9.34112 19.8933 8.19587 19.6184C7.05062 19.3434 5.99678 18.7748 5.13821 17.9686C4.27963 17.1623 3.64596 16.1463 3.29964 15.0205C2.95333 13.8948 2.90631 12.6983 3.16324 11.5488C3.42017 10.3994 3.97217 9.33677 4.76484 8.46564C5.5575 7.59451 6.56348 6.94496 7.68363 6.581C8.24578 6.39834 8.84956 6.70599 9.03221 7.26814Z",
          fill: "currentColor"
        }
      )
    ]
  }
), v0 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5 3C16.0858 3 15.75 3.33579 15.75 3.75V10.5524C16.2887 10.6085 16.8037 10.7165 17.25 10.9084V3.75C17.25 3.33579 16.9142 3 16.5 3ZM18.75 3.75C18.75 2.50736 17.7426 1.5 16.5 1.5C15.2574 1.5 14.25 2.50736 14.25 3.75V6.87803C14.0154 6.79512 13.763 6.75 13.5 6.75C12.9237 6.75 12.3981 6.96664 12 7.32292C11.6019 6.96664 11.0763 6.75 10.5 6.75C10.237 6.75 9.98458 6.79512 9.75 6.87803V5.25C9.75 4.00736 8.74264 3 7.5 3C6.25736 3 5.25 4.00736 5.25 5.25V14.25C5.25 17.9779 8.27208 21 12 21C15.7279 21 18.75 17.9779 18.75 14.25V3.75ZM8.25 5.25C8.25 4.83579 7.91421 4.5 7.5 4.5C7.08579 4.5 6.75 4.83579 6.75 5.25V14.25C6.75 17.1495 9.10051 19.5 12 19.5C14.8995 19.5 17.25 17.1495 17.25 14.25V13.125C17.25 12.8812 17.1914 12.7299 17.1192 12.6254C17.0434 12.5156 16.9161 12.4051 16.7013 12.306C16.2466 12.0961 15.5401 12 14.625 12H12.375C11.7537 12 11.25 12.5037 11.25 13.125C11.25 13.7463 11.7537 14.25 12.375 14.25H15V15.75C13.7574 15.75 12.75 16.7574 12.75 18H11.25C11.25 17.145 11.5362 16.3567 12.018 15.7259C10.8188 15.5628 9.87706 14.5899 9.76186 13.3761C8.88177 13.0706 8.25 12.2341 8.25 11.25V5.25ZM10.0713 11.8655C9.87709 11.73 9.75 11.5048 9.75 11.25V9C9.75 8.58579 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 8.58579 11.25 9V10.7526C10.7497 10.9903 10.3365 11.3816 10.0713 11.8655ZM12.75 10.5H14.25V9C14.25 8.58579 13.9142 8.25 13.5 8.25C13.0858 8.25 12.75 8.58579 12.75 9V10.5Z",
        fill: "white"
      }
    )
  }
), V0 = (i) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: /* @__PURE__ */ e(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 6L20 6V18L18 18V16H16V18H4V6L16 6L16 8H18L18 6ZM2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM9 9.5C9 8.67157 8.32843 8 7.5 8C6.67157 8 6 8.67157 6 9.5C6 10.3284 6.67157 11 7.5 11C8.32843 11 9 10.3284 9 9.5ZM12.5 13C13.3284 13 14 13.6716 14 14.5C14 15.3284 13.3284 16 12.5 16C11.6716 16 11 15.3284 11 14.5C11 13.6716 11.6716 13 12.5 13ZM18 10H16V14L18 14V10ZM6.29297 14.2928L12.293 8.29282L13.7072 9.70703L7.70718 15.707L6.29297 14.2928Z",
        fill: "white"
      }
    )
  }
), w0 = (i) => /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...i, children: /* @__PURE__ */ e(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 3.3a.7.7 0 0 1 .7.7v5a.7.7 0 0 1-.7.7h-5a.7.7 0 1 1 0-1.4h3.6a6.3 6.3 0 0 0-11.185 2.07.7.7 0 1 1-1.352-.362 7.7 7.7 0 0 1 13.238-3.072V4.001a.7.7 0 0 1 .7-.7M5.34 19.79a.7.7 0 0 1-.7-.7v-5a.7.7 0 0 1 .7-.7h5a.7.7 0 1 1 0 1.4H6.743a6.3 6.3 0 0 0 11.184-2.07.7.7 0 0 1 1.352.362 7.7 7.7 0 0 1-13.237 3.072v2.935a.7.7 0 0 1-.7.7",
    clipRule: "evenodd"
  }
) }), g0 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "circle",
        {
          cx: "12",
          cy: "12",
          r: "6",
          stroke: "#1E2532",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e("circle", { cx: "12", cy: "12", r: "1", stroke: "black", strokeWidth: "2" }),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M18 12H20",
          stroke: "#1E2532",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M4 12H6",
          stroke: "#1E2532",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M12 6V4",
          stroke: "#1E2532",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M12 20V18",
          stroke: "#1E2532",
          strokeWidth: "1.4",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), p0 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          d: "M8.80005 3.00005C8.80005 2.61345 9.11345 2.30005 9.50005 2.30005L14.5 2.30005C14.8866 2.30005 15.2 2.61345 15.2 3.00005C15.2 3.38665 14.8866 3.70005 14.5 3.70005L9.50005 3.70005C9.11345 3.70005 8.80005 3.38665 8.80005 3.00005Z",
          fill: "#828BA2"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M16.4501 12.5C16.4501 11.9813 16.3479 11.4677 16.1494 10.9884C15.9509 10.5092 15.66 10.0738 15.2932 9.70698C14.9264 9.34019 14.4909 9.04923 14.0117 8.85072C13.5325 8.65222 13.0188 8.55005 12.5001 8.55005C12.1135 8.55005 11.8001 8.86345 11.8001 9.25005C11.8001 9.63665 12.1135 9.95005 12.5001 9.95005C12.835 9.95005 13.1666 10.016 13.4759 10.1442C13.7853 10.2723 14.0664 10.4601 14.3032 10.6969C14.54 10.9337 14.7278 11.2148 14.856 11.5242C14.9841 11.8336 15.0501 12.1652 15.0501 12.5C15.0501 12.8866 15.3635 13.2 15.7501 13.2C16.1367 13.2 16.4501 12.8866 16.4501 12.5Z",
          fill: "#828BA2"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.652 9.74473C19.0138 10.6183 19.2 11.5545 19.2 12.5001C19.2 13.4456 19.0138 14.3818 18.652 15.2554C18.2901 16.1289 17.7598 16.9226 17.0912 17.5912C16.4226 18.2598 15.6289 18.7901 14.7554 19.152C13.8818 19.5138 12.9456 19.7001 12 19.7001C11.0545 19.7001 10.1183 19.5138 9.24473 19.152C8.37118 18.7901 7.57746 18.2598 6.90888 17.5912C6.2403 16.9226 5.70995 16.1289 5.34812 15.2554C4.98628 14.3818 4.80005 13.4456 4.80005 12.5C4.80005 11.5545 4.98628 10.6183 5.34812 9.74473C5.70995 8.87118 6.2403 8.07746 6.90888 7.40888C7.57746 6.7403 8.37118 6.20995 9.24473 5.84812C10.1183 5.48628 11.0545 5.30005 12 5.30005C12.9456 5.30005 13.8818 5.48628 14.7554 5.84812C15.6289 6.20995 16.4226 6.7403 17.0912 7.40888C17.7598 8.07746 18.2901 8.87118 18.652 9.74473ZM17.8 12.5001C17.8 11.7384 17.65 10.9842 17.3585 10.2805C17.0671 9.5768 16.6398 8.93741 16.1013 8.39883C15.5627 7.86025 14.9233 7.43303 14.2196 7.14155C13.5159 6.85007 12.7617 6.70005 12 6.70005C11.2384 6.70005 10.4842 6.85007 9.78049 7.14155C9.0768 7.43302 8.43741 7.86025 7.89883 8.39883C7.36025 8.93741 6.93302 9.5768 6.64155 10.2805C6.35007 10.9842 6.20005 11.7384 6.20005 12.5C6.20005 13.2617 6.35007 14.0159 6.64155 14.7196C6.93302 15.4233 7.36025 16.0627 7.89883 16.6013C8.43741 17.1398 9.0768 17.5671 9.78048 17.8586C10.4842 18.15 11.2384 18.3001 12 18.3001C12.7617 18.3001 13.5159 18.15 14.2196 17.8586C14.9233 17.5671 15.5627 17.1398 16.1013 16.6013C16.6398 16.0627 17.0671 15.4233 17.3585 14.7196C17.65 14.0159 17.8 13.2617 17.8 12.5001Z",
          fill: "#828BA2"
        }
      )
    ]
  }
), M0 = (i) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "transparent",
    ...i,
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.30078 9.00077C4.30078 8.06189 5.0619 7.30078 6.00078 7.30078L18.0008 7.30078C18.9397 7.30078 19.7008 8.0619 19.7008 9.00078V17.0008C19.7008 17.9397 18.9397 18.7008 18.0008 18.7008H6.00073C5.06184 18.7008 4.30072 17.9397 4.30073 17.0008L4.30078 9.00077ZM6.00078 8.70078C5.83509 8.70078 5.70078 8.83509 5.70078 9.00078L5.70073 17.0008C5.70073 17.1665 5.83504 17.3008 6.00073 17.3008H18.0008C18.1665 17.3008 18.3008 17.1665 18.3008 17.0008V9.00078C18.3008 8.8351 18.1665 8.70078 18.0008 8.70078L6.00078 8.70078Z",
          fill: "#828BA2"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.00072 5.20078C5.83503 5.20078 5.70072 5.3351 5.70072 5.50078L5.70072 11.5008C5.70072 11.8874 5.38732 12.2008 5.00072 12.2008C4.61412 12.2008 4.30072 11.8874 4.30072 11.5008L4.30072 5.50078C4.30072 4.5619 5.06184 3.80078 6.00072 3.80078L16.0007 3.80078C16.9396 3.80078 17.7007 4.5619 17.7007 5.50078V7.50078C17.7007 7.88738 17.3873 8.20078 17.0007 8.20078C16.6141 8.20078 16.3007 7.88738 16.3007 7.50078V5.50078C16.3007 5.3351 16.1664 5.20078 16.0007 5.20078L6.00072 5.20078Z",
          fill: "#828BA2"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          d: "M16.3808 13.0004C16.3808 13.4974 15.9779 13.9004 15.4808 13.9004C14.9837 13.9004 14.5808 13.4974 14.5808 13.0004C14.5808 12.5033 14.9837 12.1004 15.4808 12.1004C15.9779 12.1004 16.3808 12.5033 16.3808 13.0004Z",
          fill: "#828BA2"
        }
      )
    ]
  }
), f0 = (i) => /* @__PURE__ */ t("svg", { id: "NeverUsed24", ...i, children: [
  /* @__PURE__ */ e("path", { fill: "#339D5D", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z" }),
  /* @__PURE__ */ e(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M11.097 5.071 12.5 6.5l-4.246 4.613c-.478.525-.906.507-1.403 0L4 8.5l1.403-1.429 2.15 1.9 3.544-3.9Z",
      clipRule: "evenodd"
    }
  )
] }), u0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Add: C,
  AddMiddle: l,
  AddSmall: h,
  ArrowDown: s,
  ArrowRight: o0,
  ArrowTarget: L0,
  ArrowTargetAutoTailoring: c0,
  ArrowUp: n,
  Bag: j1,
  BellIcon: d0,
  BellOutlineIcon: n0,
  BindLink: O,
  Bold: E,
  Brave: a0,
  Briefcase: w2,
  Burger: u1,
  BurgerClose: x1,
  Calendar: w1,
  CalendarOutlined: g1,
  CareerTick: g,
  Careerminds: _,
  Cash: r,
  Chevron: M,
  ChevronDown: x2,
  ChevronLeft: f,
  ChevronLightDown: R2,
  ChevronLightUp: B2,
  ChevronRight: Z,
  ChevronUp: u,
  CircleError: Q1,
  CircleSuccess: N1,
  CircleWithLines: i0,
  ClockIcon: t0,
  Close: x,
  CloseBig: B,
  CloseIcon: H,
  CloseLarge: k,
  Combine: O1,
  Company: V1,
  Completeness0Percent: D2,
  Completeness50Percent: U2,
  Dashboard: G2,
  DashboardActive: Y2,
  DashboardBuilder: e0,
  Deal: V0,
  Description: a,
  Documents: P2,
  DocumentsActive: q2,
  DoubleStars: u2,
  Download: K,
  DownloadIcon: l0,
  Duplicate: Y,
  Edge: r0,
  Edit: $,
  EditAlt: e1,
  Ellipsis: f2,
  Email: s1,
  EmailOutline: r1,
  Error: J1,
  Error2: I2,
  EventSearch: Z2,
  Export: k1,
  Extension: v2,
  ExternalLink: e2,
  ExternalLinkCurved: i2,
  FaceBad: q1,
  FaceGood: $1,
  FaceNormal: K1,
  Facebook: C1,
  FeaturedIcon: h0,
  FilePdfColor: C2,
  FilePdfGray: h2,
  FileTxt: U1,
  FileTxtColor: d2,
  FileWord: T1,
  FileWordColor: l2,
  FileWordGray: o2,
  Filter: f1,
  FontSize: m,
  FontSizeLock: R,
  ForwardIcon: T2,
  FullSize: A,
  FullSizeLarge: z,
  Gift: Z1,
  Google: n1,
  Grid: V,
  HandModern: v0,
  Heart: p2,
  HeartFullFilled: M2,
  Hint: _1,
  HintClose: z1,
  HintOutlined: A1,
  Home: a2,
  House: r2,
  IconSend: s0,
  ImageLarge: F1,
  ImageSmall: R1,
  Info: E2,
  Instagram: h1,
  Interview: c2,
  Invisible: b1,
  InvisibleSmall: W1,
  Italic: S,
  Job: X1,
  JobSearch: I1,
  JobTracker: L2,
  Jobs: N2,
  JobsActive: K2,
  LeftArrow: Q,
  LineSpacingIcon: F,
  Link: G,
  Linkedin: d1,
  ListIcon: j2,
  LoaderQuarter: t2,
  Location: p1,
  LocationOutlined: M1,
  Lock: H1,
  LogOut: S2,
  Mail: y1,
  Mic: b2,
  MicClosed: W2,
  MoneyIcon: C0,
  More: E1,
  MoreMenu: Q2,
  Near: g0,
  NeverUsed: f0,
  NewLocation: A2,
  NewSearch: m2,
  OrderedList: D,
  Pdf: k2,
  Person: L,
  Pin: S1,
  Play: a1,
  RedWarning: Y1,
  Remove: o,
  RemoveAlt: d,
  Revert: i1,
  RightArrow: J,
  Rotate: t1,
  Screen: g2,
  Search: v1,
  Settings: y,
  Settings2: y2,
  Share: b,
  Simple: n2,
  SimpleFilled: s2,
  SnackbarWarning: G1,
  Sound: z2,
  SpellCheck: P,
  SpellCheckPending: N,
  Spinner: B1,
  SpinnerV2: m1,
  Star: c1,
  Strike: U,
  Success: P1,
  Target: O2,
  Text: _2,
  Tick: w,
  TickIcon: D1,
  TickLarge: p,
  Tiktok: l1,
  Timer: p0,
  ToggleArrow: c,
  Tracker: J2,
  TrackerActive: X2,
  Trash: v,
  TryItChevron: $2,
  Twitter: L1,
  UnbindLink: I,
  Underline: T,
  UnorderedList: j,
  UpdateIcon: w0,
  Upload: q,
  UploadResume: H2,
  View: W,
  Wallet: M0,
  Word: F2,
  WorkBag: V2,
  Youtube: o1,
  Zoom: X
}, Symbol.toStringTag, { value: "Module" }));
export {
  O as $,
  C as A,
  A as B,
  f as C,
  a as D,
  z as E,
  K1 as F,
  V as G,
  A1 as H,
  b as I,
  y as J,
  E as K,
  p1 as L,
  E1 as M,
  A2 as N,
  S as O,
  L as P,
  j as Q,
  o as R,
  B1 as S,
  p0 as T,
  H2 as U,
  W as V,
  M0 as W,
  D as X,
  U as Y,
  T as Z,
  u0 as _,
  t0 as a,
  h2 as a$,
  I as a0,
  G as a1,
  P as a2,
  N as a3,
  J as a4,
  Q as a5,
  Y as a6,
  q as a7,
  K as a8,
  X as a9,
  R1 as aA,
  F1 as aB,
  _1 as aC,
  z1 as aD,
  b1 as aE,
  W1 as aF,
  y1 as aG,
  S1 as aH,
  j1 as aI,
  D1 as aJ,
  U1 as aK,
  T1 as aL,
  O1 as aM,
  I1 as aN,
  G1 as aO,
  P1 as aP,
  N1 as aQ,
  J1 as aR,
  Q1 as aS,
  Y1 as aT,
  q1 as aU,
  X1 as aV,
  $1 as aW,
  e2 as aX,
  i2 as aY,
  t2 as aZ,
  C2 as a_,
  $ as aa,
  e1 as ab,
  i1 as ac,
  t1 as ad,
  C1 as ae,
  h1 as af,
  l1 as ag,
  o1 as ah,
  d1 as ai,
  n1 as aj,
  s1 as ak,
  r1 as al,
  a1 as am,
  L1 as an,
  c1 as ao,
  V1 as ap,
  w1 as aq,
  g1 as ar,
  M1 as as,
  f1 as at,
  Z1 as au,
  u1 as av,
  x1 as aw,
  H1 as ax,
  k1 as ay,
  m1 as az,
  M2 as b,
  l2 as b0,
  o2 as b1,
  d2 as b2,
  n2 as b3,
  s2 as b4,
  r2 as b5,
  a2 as b6,
  L2 as b7,
  c2 as b8,
  v2 as b9,
  P2 as bA,
  N2 as bB,
  J2 as bC,
  Q2 as bD,
  Y2 as bE,
  q2 as bF,
  K2 as bG,
  X2 as bH,
  $2 as bI,
  e0 as bJ,
  i0 as bK,
  C0 as bL,
  h0 as bM,
  l0 as bN,
  o0 as bO,
  d0 as bP,
  n0 as bQ,
  s0 as bR,
  r0 as bS,
  a0 as bT,
  L0 as bU,
  c0 as bV,
  v0 as bW,
  V0 as bX,
  w0 as bY,
  g0 as bZ,
  f0 as b_,
  V2 as ba,
  w2 as bb,
  g2 as bc,
  f2 as bd,
  Z2 as be,
  u2 as bf,
  x2 as bg,
  k2 as bh,
  B2 as bi,
  m2 as bj,
  R2 as bk,
  F2 as bl,
  _2 as bm,
  z2 as bn,
  b2 as bo,
  W2 as bp,
  y2 as bq,
  E2 as br,
  S2 as bs,
  j2 as bt,
  D2 as bu,
  U2 as bv,
  T2 as bw,
  O2 as bx,
  I2 as by,
  G2 as bz,
  p2 as c,
  x as d,
  v1 as e,
  Z as f,
  h as g,
  l as h,
  d as i,
  n as j,
  s as k,
  r as l,
  c as m,
  v as n,
  w as o,
  g as p,
  p as q,
  M as r,
  u as s,
  H as t,
  k as u,
  B as v,
  m as w,
  R as x,
  F as y,
  _ as z
};
